import { Image } from 'primereact/image';
import React, { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { InputText } from "primereact/inputtext";
import Layout from "../../components/common/nav/initiator/nav.component";
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import { ValidateAllRoleExceptAdmin, } from '../../helper/validateRole';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import sideBarRight from "../../assets/images/sidebarright.svg"
import Editpopup from "../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from '../../setup/auth/login.component';
import sidebar from "../../assets/images/sidebarright.svg"
import { Dropdown } from 'primereact/dropdown';
import { Avatar } from 'primereact/avatar';
import { FilterMatchMode, } from 'primereact/api';
import { ConvertResponseForSelect, GetValueFromArray, graphQLGetAllData, graphQLFindRecordById } from '../../helper/commonfunctions';
import { handleNotificationsOnStatusChangeforTimeReport } from '../../components/actions/notficationActions';
import { Timeline } from 'primereact/timeline';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../graphql/mutations';
import * as queries from "../../graphql/queries";
import ReportDeleteDialog from '../../components/reportSoftDelete';

import {
    Schools, Subject,
    SixthPeriodAssignmentInitiateReport,
    SixthPeriodReportTransactionCycle,
    TimeReportInitiateReport,
    TimeReportTransactionCycle,
    TimeReportEmployee,
    TimeReportEmployeeDetails,
    Employee,

} from "../../models";

import moment from "moment";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { Calendar } from 'primereact/calendar';
import empDetailsImg from '../../assets/images/applicationImg.png';
import { toast } from 'react-toastify';
import { Request_Status } from '../../helper/enum';
import { reactLocalStorage } from 'reactjs-localstorage';
import HtmlToPdf from '../../components/HtmlToPdf';
import { TabPanel, TabView } from 'primereact/tabview';
import { USER_TYPES, USER_TYPES_NAMES } from "../../helper/enum";
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import HtmlToPdfTimeReport from '../../components/time_report/htmlToPdf';
import { useReactToPrint } from "react-to-print";
import time_report from './time_report.css';
import handleDateSelect from '../../helper/convertDateIntoPSTFormat';
import { ProgressSpinner } from 'primereact/progressspinner';


export default function TimeReportSuperAdminList() {

    const [isLoading, setIsLoading] = useState(false);

    //notification remainder start
    const [ReminderDialog, setreminderDialog] = useState(false);
    const [ReminderData, setreminderData] = useState(null);
    const [isVisibleDelete, setIsVisibleDelete] = useState(false);
    const [isVisibleDeleteID, setIsVisibleDeleteID] = useState(null);
    const [isUpdateData, setIsUpdateData] = useState('');

    const RemainderFunction = async (rowData) => {
        try {
            let status = 'REMINDER_PENDING_FOR_APPROVAL'
            let userid = rowData.assigneeId;
            console.log("useriduserid:-", userid);
            // if (rowData.approver_by) {
            //     status = "REMINDER_PENDING_FOR_PAYROLL"
            //     userid = rowData.l2_authority
            // }
            console.log(status)
            handleNotificationsOnStatusChangeforTimeReport(status, rowData?.id, "TIME_REPORT", userid, loggedUserId);
            setreminderDialog(false);
            toast.success("Remainer Sent Sucessfully")
        } catch (err) {
            console.log("Error is :-", err);
        }
    }


    const footerContentForReminder = (
        <div className="text-center">
            <div className="d-flex">
                <button
                    onClick={() => { RemainderFunction(ReminderData) }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                >
                    Yes
                </button>
                <button
                    onClick={() => { setreminderDialog(false) }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                    id="add-family-cancel-btn"
                >
                    No
                </button>
            </div>
        </div>
    );
    //notification remainder end

    const { tr_ReportId } = useParams();
    const [typeOfUser, setTypeOfUser] = useState();
    const loggedUserRole = reactLocalStorage.get('loggedUserRole');

    const [isFormApproved, setIsFormApproved] = useState();

    const { type } = useParams();

    const location = useLocation();

    useEffect(() => {
        const parts = location.pathname.split('/');
        const lastPart = parts[parts.length - 1];
        setTypeOfUser(lastPart)
        console.log('Last Part of Current Route TR:', lastPart);
        localStorage.setItem("lastPart", lastPart);
        if (tr_ReportId) {
            if (loggedUserRole === "I" && lastPart === "initiator") {
                const path =
                    `/time_report/${tr_ReportId}`;
                navigateTo(path);
                navigateTo(0);
            }
            else if (loggedUserRole === "AP" && lastPart === "approver") {
                const path =
                    `/time_report/${tr_ReportId}`;
                navigateTo(path);
                navigateTo(0);
            }
            else if (loggedUserRole === "P" && lastPart === "payroll") {
                const path =
                    `/time_report/${tr_ReportId}`;
                navigateTo(path);
                navigateTo(0);
            }
            else {
                reactLocalStorage.clear();
                navigateTo(`/time_report/${tr_ReportId}/${lastPart}`);
            }
        }
        else {
            navigateTo(location.pathname);
        }

    }, [location.pathname]);

    let [events, setEvents] = useState([]);
    let navigateTo = useNavigate();
    const [reportLoading, setReportLoading] = useState(true);

    const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
    const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);

    const [viewEmployeeDetailsData, setViewEmployeeDetailsData] = useState([]);
    const [pages, setPages] = useState([]);
    const [allApproverList, setAllApproverList] = useState([]);
    const [allRejectionList, setAllRejectionList] = useState([]);
    const [submittedBy, setSubmittedBy] = useState('');
    const [totalRowspan, settotalRowspan] = useState('');
    const [latestDatesLength, setDatesLength] = useState([]);
    const [latestMonths, setLatestMonths] = useState([]);
    const [latestDates, setLatestDates] = useState([]);
    // console.log("specificReportDetails0311", pages);
    var dates = [];
    var months = [];
    var datesLength = [];
    var totalRowSpans = 0;
    let finalData = [];



    const getData = async (requestedDataId, startNewDate, endNewDate) => {
        setIsLoading(true)
        let empTableData = [];
        const cognito = new AWS.CognitoIdentityServiceProvider();
        // const timeReportEmpResp = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(requestedDataId));
        const timeReportEmpResp = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: requestedDataId } }])

        //console.log(timeReportEmpResp)
        let totallen = [];

        for (let i = 0; i < timeReportEmpResp.length; i++) {
            let response = await getTimeReportEmployeeDetails(timeReportEmpResp[i].id, startNewDate, endNewDate)
            totallen[i] = response.length

            var employeeResponses1 = await graphQLFindRecordById("getEmployee", timeReportEmpResp[i].employee_Id)
            // var employeeResponses1 = await DataStore.query(Employee , timeReportEmpResp[i].employee_Id);     

            let empName = ''
            let empCode = ''
            if (employeeResponses1) {
                empName = employeeResponses1.employee_name;
                empCode = employeeResponses1.employee_code
            }

            let data = {
                "id": timeReportEmpResp[i].id,
                "employee_Id": timeReportEmpResp[i].employee_Id,
                "time_Report_Id": timeReportEmpResp[i].time_Report_Id,
                "pay_Rate": timeReportEmpResp[i].pay_Rate,
                "totalEmployeeWorkingHours": timeReportEmpResp[i].totalEmployeeWorkingHours,
                "employeeResponseArray": response,
                "employeeName": empName,
                "userCode": empCode

            }

            // console.log(empTableData, 'empTableDataempTableData')
            empTableData.push(data);
            if (i === timeReportEmpResp.length - 1) {
                let endCounter = 0;
                let pageNo = 2;
                const rows = [];
                console.log('empTableData.length', empTableData.length)
                for (let i = 16; i <= empTableData.length; i += 23) {
                    endCounter = i + 23;
                    rows.push({ 'start': i, 'empTableData': empTableData, 'end': endCounter, 'pageNo': pageNo++ })
                }
                console.log("Rows1234", rows);
                setPages(rows)
                setViewEmployeeDetailsData(empTableData)
            }
        }
        totalRowSpans = totallen.length > 0 ? totallen.sort((a, b) => b - a) : 0
        settotalRowspan(totalRowSpans)

        var getTimeReportInitiate = await graphQLFindRecordById("getTimeReportInitiateReport", requestedDataId)
        // var getTimeReportInitiate = await DataStore.query(TimeReportInitiateReport, requestedDataId)

        let timeReportTransactionCycleLate = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: requestedDataId } }])
        timeReportTransactionCycleLate = timeReportTransactionCycleLate ? timeReportTransactionCycleLate.sort((a, b) => a.createdAt.localeCompare(b.createdAt)) : [];

        /* const timeReportTransactionCycleLate = await DataStore.query(TimeReportTransactionCycle, (c) => c.report_Id.eq(requestedDataId), {
            sort: (s) => s.createdAt(SortDirection.ASCENDING)
        }); */
        // console.log("timeReportTransactionCycleLate--", timeReportTransactionCycleLate);

        const employeeResponses = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: getTimeReportInitiate.Created_By } }])
        console.log(employeeResponses, "employeeResponses11")
        let listApprovers = [];
        let listRejectedStatus = [];
        if (employeeResponses.length) {
            for (let i = 0; i < timeReportTransactionCycleLate.length; i++) {

                if (i === 0) {
                    let obj = {
                        empName: employeeResponses[0].firstName + " " + employeeResponses[0].lastName,
                        empTitle: 'Initiator',
                        empCode: employeeResponses[0].employee_code,
                        status: 'Submitted',
                        date: (timeReportTransactionCycleLate[i].createdAt) ? timeReportTransactionCycleLate[i].createdAt : timeReportTransactionCycleLate[i].customUpdatedAt

                    }
                    setSubmittedBy(obj);
                }

                let payrollApproval;
                if (timeReportTransactionCycleLate[i].isApproved) {
                    if (timeReportTransactionCycleLate[i].to_Employee_Id) {
                        payrollApproval = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: timeReportTransactionCycleLate[i].to_Employee_Id } }])
                    }

                    let pApprovalFirstName = payrollApproval ? payrollApproval[0].firstName : "";
                    let pApprovalLastName = payrollApproval ? payrollApproval[0].lastName : "";
                    let fullName = pApprovalFirstName + " " + pApprovalLastName
                    let appDate = handleDateSelect(timeReportTransactionCycleLate[i].customUpdatedAt)
                    listApprovers.push({ name: fullName, date: appDate })
                } else if (timeReportTransactionCycleLate[i].status == 'Rejected') {
                    if (timeReportTransactionCycleLate[i].to_Employee_Id) {
                        payrollApproval = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: timeReportTransactionCycleLate[i].to_Employee_Id } }])
                    }

                    let pApprovalFirstName = payrollApproval ? payrollApproval[0].firstName : "";
                    let pApprovalLastName = payrollApproval ? payrollApproval[0].lastName : "";
                    let fullName = pApprovalFirstName + " " + pApprovalLastName
                    let appDate = handleDateSelect(timeReportTransactionCycleLate[i].customUpdatedAt)
                    listRejectedStatus.push({ name: fullName, date: appDate })
                }
            }
        }
        setAllApproverList(listApprovers)
        setAllRejectionList(listRejectedStatus)
        setIsLoading(false)
    }

    const getTimeReportEmployeeDetails = async (timeReportEmpRespId, startDate, endDate) => {

        const timeReportEmpDetailsResp = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: timeReportEmpRespId } }])
        // const timeReportEmpDetailsResp = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmpRespId));

        let datesArray = await getDates(startDate, endDate);
        let finalData = [];
        for (let i = 0; i < datesArray.length; i++) {
            let getMatchDateResponse = timeReportEmpDetailsResp.filter((item) => item.date === datesArray[i]);
            let data;
            if (getMatchDateResponse.length > 0) {
                data = {
                    "date": datesArray[i],
                    "totalHours": getMatchDateResponse[0].totalHoursAndMinDisplay,
                }
            } else {
                data = {
                    "date": datesArray[i],
                    "totalHours": "-",
                }
            }
            finalData.push(data)
        }
        return finalData;
    }

    const getDates = async (startDate, endDate) => {
        var dates = [];
        var current = moment(startDate);
        var end = moment(endDate);
        while (current <= end) {
            dates.push(current.format('YYYY-MM-DD'));
            current.add(1, 'days');
        }
        return dates;
    }

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        period: { value: null, matchMode: FilterMatchMode.CONTAINS },
        schoolDept: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
        remark: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Assignee: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });


    const [selectedEmployeeForApprovals, setSelectedEmployeeForApprovals] = useState(""); //useState({ name: "No Approval Needed", code: 'no_approval_needed' });
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedReportingManagerEmployee, setSelectedReportingManagerEmployee] = useState(null);
    const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
    const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
    const [empCodeList, setEmpCodeList] = useState([]);
    const [empCodeListForRM, setEmpCodeListForRM] = useState([]);

    const [userloggedRole, setUserRole] = useState("");
    const [timeReportIsInitiator, setTimeReportIsInitiator] = useState("");
    const [timeReportIsApprover, setTimeReportIsApprover] = useState("");
    const [timeReportIsPayroll, setTimeReportIsPayroll] = useState("");
    const [timeReportIsSuperadmin, setTimeReportIsSuperadmin] = useState("");



    //states start
    const [isPrintClick, setIsPrintClick] = useState(false);
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const printWithDelay = () => {
        handlePrint();
    };



    //count and active index states
    const [activeIndex, setActiveIndex] = useState(0);
    const [submitCount, setSubmitCount] = useState(0);
    const [approvedCount, setApprovedCount] = useState(0);
    const [rejectCount, setRejectCount] = useState(0);
    const [pendingForApprovalCountForReqReportsCount, setPendingForApprovalCountForReqReports] = useState(0);
    const [approvedCountForReqReportsCount, setApprovedCountForReqReports] = useState(0);
    const [rejectCountForReqReportsCount, setRejectCountForReqReports] = useState(0);

    //report list
    const [initiatorReportList, setInitiatorReportList] = useState([]);
    const [approvalReportRequestList, setApprovalReportRequest] = useState([]);
    const [fullViewEdit, setFullViewEdit] = useState(false);
    const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
    const [showNextPopUp, setShowNextPopUp] = useState(false);
    const [confirmVisible2, setConfirmVisible2] = useState(false);
    const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
    const [groupName, setGroupName] = useState();
    const [accountCharge, setAccountCharged] = useState('');
    const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState('');
    const [subjectCode, setSubjectCodeList] = useState(null);
    const [fteUtilized, setFteUtilized] = useState('');
    //------------


    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [visible, setVisible] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [visibleRequestedReportEdit, setVisibleRequestedReportEdit] = useState(false);
    const [visiblePayrollEdit, setVisiblePayrollEdit] = useState(false);
    const [checkedSignature, setCheckedSignature] = useState(false);
    const [needMoreApprovals, setNeedMoreApprovals] = useState(false);
    const [showNeedMoreApprovals, setShowNeedMoreApprovals] = useState(false);
    const [rejectVisible, setRejectVisible] = useState(false);
    const [rejectMsgValue, setRejectValueMsg] = useState('');
    const [sendMsg, setSendMsg] = useState(false);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [requestApprovalConfirmVisible, setRequestApprovalConfirmVisible] = useState(false);
    const [position, setPosition] = useState('center');
    const [visibleRight, setVisibleRight] = useState(false);
    const [activate, setActivate] = useState("");
    const [isMasterDataLoaded, setIsMasterDataLoaded] = useState(false);

    const [timeReportTransactionCyclesList, setTimeReportTransactionCyclesList] = useState([]);
    const [timeReportEmployeesList, setTimeReportEmployeesList] = useState([]);
    const [timeReportEmployeeDetailsList, setTimeReportEmployeeDetailsList] = useState([]);
    //footer Content code start
    const footerContent = (
        <div className='text-center'>
            <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false) }}>Close</button>
        </div>
    );
    const footerContent1 = (
        <div className='text-center'>
            <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible2(false); setShowNextPopUp(false); setVisibleCreteReportPopup(false); setShowPreviewPopUp(false); }}>Close</button>
        </div>
    );
    const footerContentForReqApproval = (
        <div className='text-center'>
            <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setReportLoading(true); getMasterData(); BindList(); setRequestApprovalConfirmVisible(false); setVisibleRequestedReportEdit(false); }}>Close</button>
        </div>
    );
    const footerContentForReqReject = () => (
        <div className='text-center'>
            <div className="mb-10 px-5 py-3 flex gap-2 justify-center">
                {
                    (sendMsg) ?
                        <button className='bg-[#113699] border border-[##113699] text-white px-8 py-2 rounded' onClick={() => {
                            BindList();
                            getMasterData();
                            setRejectVisible(false);
                            setVisibleRequestedReportEdit(false);
                            setRequestApprovalConfirmVisible(false);
                            setSendMsg(false);
                        }}>Ok</button> :
                        <button
                            className='bg-[#113699] border border-[##113699] text-white px-8 py-2 rounded'
                            onClick={() => {
                                rejectSelectedReport(specificReportDetailsEdit.id);
                                setSendMsg(false);
                            }}>Send</button>
                }

                <button
                    onClick={() => setRejectVisible(false)}
                    className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                >
                    <i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>
                    Cancel
                </button>
            </div>
        </div>
    );
    //footer Content code end

    //*state
    const [reportId, setReportId] = useState('');
    const [schoolName, setSchoolName] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [status, setStatus] = useState('');
    const [schoolList, setSchoolList] = useState('');
    const [schoolAllList, setAllSchoolList] = useState('');
    const [schoolSelect, setSelectedSchool] = useState('');
    const [closedCount, setClosedCount] = useState('');
    const [openCount, setOpenCount] = useState('');


    //*List
    const [employeeList, setEmployeeList] = useState([]);
    const [reportEmployeeList, setReportEmployeeList] = useState([]);
    const [users, SetUsersList] = useState([]);


    const [absentCodeListDropdown, setSubjectListDropdown] = useState();
    const loggedUserId = reactLocalStorage.get('loggedUserId');

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [assighnmentTitle, setAssighnmentTitle] = useState('');


    //status format and layout code start
    const TaskStatusSL = (product) => {
        switch (product.status) {
            case 'Reviewed & resubmitted':
                return 'info';

            case 'Rejected':
                return 'danger';

            case 'Closed':
                return 'success';

            case 'Submitted':
                return 'info';

            case 'Approved':
                return 'success';

            case 'Open':
                return 'info';


            case 'Approved (P)':
                return 'success';

            default:
                return null;
        }
    };
    const TaskStatusSLA = (product) => {
        return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
    };
    const requestReportStatusOptions = (product) => {

        switch (product.status) {
            case 'Rejected':
                return 'danger';

            case 'Pending for Approval':
                return 'warning';

            case 'Closed':
                return 'info';

            case 'Open':
                return 'info';

            case 'SUBMITTED':
                return 'info';
            case 'Approved':
                return 'success';

            default:
                return null;
        }
    };
    const approveStatusOptions = (product) => {

        switch (product.status) {
            case 'Rejected':
                return 'danger';
            case 'Submitted':
                return 'info';
            case 'Pending':
                return 'warning'
            case 'Pending For Approval':
                return 'warning';
            case 'Open':
                return 'info';
            case 'Closed':
                return 'success';
            case 'Approved':
                return 'success';

            default:
                return null;
        }
    };
    const requestReportStatus = (product) => {


        return <Tag value={product.status} severity={requestReportStatusOptions(product)}></Tag>;
    };
    const approvalStatusBody = (product) => {
        return <Tag value={product.status} severity={approveStatusOptions(product)}></Tag>;
    };
    //status format and layout code end


    //action layout code start
    const initiateReportAction = (row) => {

        console.log("rowrowrow:-", row);

        return (
            <div className="flex justify-center w-full grid grid-cols-3  gap-2 items-center" >

                {
                    //row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickInitiateRequestViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                    row.status === "Approved" ?
                        <>
                            {/* <Link to='#' className="py-2 px-2.5" onClick={() => onClickInitiateRequestViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> */}
                            <Link to='#' className="py-2 px-2.5"
                                        onClick={() => {
                                            navigateTo('/timereport/initiatenewreport/' + row.id + '/' + "EditBySA"); navigateTo(0)
                                        }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                            {(row?.Assignee != "-") ?
                                <Link
                                    to="#"
                                    className="py-2 px-2.5 pt-2"
                                    onClick={() => {
                                        setreminderDialog(true)
                                        setreminderData(row)
                                    }}
                                >
                                    <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                                </Link> : null}
                            {

                               
                                    <Link
                                        to="#"
                                        // icon="pi pi-trash"
                                        className="pi pi-trash py-2 px-2.5 pt-2 text-[#667085]"
                                        onClick={() => {
                                            setIsVisibleDeleteID(row.id);
                                            setIsVisibleDelete(true)
                                        }}
                                    /> 

                            }

                        </>
                        :
                        row.status === "Reviewed & resubmitted" ?
                            <>
                                <Link to='#' className="py-2 px-2.5"
                                    onClick={() => {
                                        navigateTo('/timereport/initiatenewreport/' + row.id + '/' + "EditBySA"); navigateTo(0)
                                    }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                                <Link
                                    to="#"
                                    className="py-2 px-2.5 pt-2"
                                    onClick={() => {
                                        setreminderDialog(true)
                                        setreminderData(row)
                                    }}
                                >
                                    <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                                </Link>
                                <Link
                                    to="#"
                                    // icon="pi pi-trash"
                                    className="pi pi-trash py-2 px-2.5 pt-2 text-[#667085]"
                                    onClick={() => {
                                        setIsVisibleDeleteID(row.id);
                                        setIsVisibleDelete(true)
                                    }}
                                />
                            </>
                            : row.status === "Closed" ?
                                <>
                                    <Link to='#' className="py-2 px-2.5"
                                        onClick={() => onClickInitiateRequestViewPopup(row, 'right')}>
                                        <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
                                    </Link>
                                    <Link
                                        to="#"
                                        className="py-2 px-2.5 pt-2"
                                    >
                                        <i className="text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                                    </Link>
                                    <Link
                                        to="#"
                                        // icon="pi pi-trash"
                                        className="pi pi-trash py-2 px-2.5 pt-2 text-[#667085]"
                                        onClick={() => {
                                            setIsVisibleDeleteID(row.id);
                                            setIsVisibleDelete(true)
                                        }}
                                    />
                                </>
                                : <>
                                    <Link to='#' className="py-2 px-2.5"
                                        onClick={() => {
                                            navigateTo('/timereport/initiatenewreport/' + row.id + '/' + "EditBySA"); navigateTo(0)
                                        }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                                    {
                                        (row.status == "Submitted") ?
                                            <Link
                                                to="#"
                                                className="py-2 px-2.5 pt-2"
                                                onClick={() => {
                                                    setreminderDialog(true)
                                                    setreminderData(row)
                                                }}
                                            >
                                                <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                                            </Link> : <Link
                                                to="#"
                                                className="py-2 px-2.5 pt-2"
                                            >
                                                <i className="text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                                            </Link>
                                    }
                                    <Link
                                        to="#"
                                        // icon="pi pi-trash"
                                        className="pi pi-trash py-2 px-2.5 pt-2 text-[#667085]"
                                        onClick={() => {
                                            setIsVisibleDeleteID(row.id);
                                            setIsVisibleDelete(true)
                                        }}
                                    />

                                </>


                }





                {/* added bell icon */}
                {/* {
                    (row?.Assignee != "-") ?
                        <Link
                            to="#"
                            className="py-2 px-2.5 pt-2"
                            onClick={() => {
                                setreminderDialog(true)
                                setreminderData(row)
                            }}
                        >
                            <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                        </Link>
                        :
                        <button
                            to="#"
                            className="py-2 px-2.5 pt-2"
                            onClick={() => {
                                if (row.status == "Pending") {
                                    toast.info("This Report is Not Submitted");
                                } else {
                                    toast.info("This Report is Closed by Payroll");
                                }
                            }}
                        >
                            <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                        </button>
                } */}


            </div>
        );
    };
    const requestedReportAction = (row) => {

        return (
            <div className="flex justify-center w-full gap-2">
                {
                    row.status === 'Pending for Approval' ?
                        <Link to='' className="py-2 px-2.5"
                            // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
                            onClick={() =>
                                onClickRequestedReportEditPopUp(row)
                            }
                        ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                        :
                        row.status === 'Approved' ?
                            <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                            row.status === 'Rejected' ?
                                <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                                null
                }
            </div>
        );
    };


    const payrollAction = (row) => {
        return (
            <div className="flex justify-center w-full gap-2">
                {
                    row.status === 'Pending for Approval' || row.status === 'Open' ?
                        <Link to='' className="py-2 px-2.5"
                            // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
                            onClick={() =>
                                onClickPayrollEditPopUp(row)
                            }
                        ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                        :
                        row.status === 'Approved' || row.status === 'Closed' ?
                            <Link to='' className="py-2 px-2.5" onClick={() => onClickPayrollViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                            row.status === 'Rejected' ?
                                <Link to='' className="py-2 px-2.5" onClick={() => onClickPayrollViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                                null
                }
            </div>
        );
    };
    //action layout code end

    //* onclick view popup
    const onClickInitiateRequestViewPopup = async (requestData, position) => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        //set transaction cycle data
        try {

            // const particularReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle,
            //     (c) => c.report_Id.eq(requestData.id),
            //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
            // );

            let particularReportTransactionCycleResponse = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(requestData.id))
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));


            if (particularReportTransactionCycleResponse) {

                let transactionArray = [];
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            console.log(e)
                        }

                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
                        let fullName = userLastName + " " + userFirstName

                        let empTitle = '';
                        if (requestData.firstApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Principal/ Dept Head';
                        }
                        else if (requestData.budgetClerk == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Clerk';
                        }

                        else if (requestData.secondApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Manager';
                        }
                        else if (requestData.payrollID == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Payroll';
                        }

                        if (i == 0) {
                            let initiatorUsers;

                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: requestData.initiatorId,
                                }).promise();
                            } catch (e) {
                                console.log(e)
                            }

                            let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            let userCodeEmp1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:userCode") : ''
                            let initiatorFullName = userLastName1 + " " + userFirstName1;

                            let obj = {
                                empName: initiatorFullName,
                                empTitle: 'Initiator',
                                empCode: userCodeEmp1,
                                status: 'Submitted',
                                date: particularReportTransactionCycleResponse[i].createdAt ? handleDateSelect(particularReportTransactionCycleResponse[i].createdAt) : null

                            }

                            transactionArray.push(obj);
                        }
                        let obj = {
                            empName: fullName,
                            empTitle: empTitle,
                            empCode: userCodeEmp,
                            status: (particularReportTransactionCycleResponse[i].status == 'Open') ? 'Pending' : particularReportTransactionCycleResponse[i].status,
                            date: ((particularReportTransactionCycleResponse[i].status != 'Open')) ? (particularReportTransactionCycleResponse[i].customUpdatedAt ? handleDateSelect(particularReportTransactionCycleResponse[i].customUpdatedAt) : handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt)) : '-'
                            // updatedAt:appDate,
                            // isApproved: particularReportTransactionCycleResponse[i].isApproved,                            
                            //status: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? 'Completed' : (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover[0].status) == 'PENDING' ? 'Pending' : statusReport)),
                            //status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
                        }
                        transactionArray.push(obj);
                    }
                }
                setEvents(transactionArray);
                console.log("transactionArraytransactionArray view:-", transactionArray);
            }


        } catch (err) {
            console.log(err)
        }


        //get specific report employee data for report:-TimeReportEmployee table
        // const timeReportEmpResp = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(requestData.id));
        const timeReportEmpResp = timeReportEmployeesList.filter(e => e.time_Report_Id.includes(requestData.id))

        //fetch user data
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
        users.forEach((user, i) => {

            userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
            userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
            userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

            let obj = {
                "userId": sub,
                "name": userName,
                "email": userEmail,
                "usercode": userCode,
                "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
            }
            newRes.push(obj);
        }
        );

        let empData = [];
        let empTableData = [];

        for (let j = 0; j < timeReportEmpResp.length; j++) {

            //particular employee get details data
            // const timeReportEmpDetailsResp = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmpResp[j].id));
            const timeReportEmpDetailsResp = timeReportEmployeeDetailsList.filter(e => e.time_Report_Employee_Id.includes(timeReportEmpResp[j].id))
            let object = {};
            const cognito = new AWS.CognitoIdentityServiceProvider();
            // if (currentItem.userId === timeReportEmpResp[j].employee_Id) {

            // var employeeResponses1 = await DataStore.query(Employee, timeReportEmpResp[j].employee_Id);
            var employeeResponses1 = await graphQLFindRecordById("getEmployee", timeReportEmpResp[j].employee_Id)

            let empName = ''
            let userCode = ''
            if (employeeResponses1) {
                empName = employeeResponses1.employee_name;
                userCode = employeeResponses1.employee_code
            }

            for (let i = 0; i < newRes.length; i++) {
                const currentItem = newRes[i];

                if (timeReportEmpResp[j].employee_Id) {
                    empData.push(currentItem);
                    object = {
                        startDate: requestData.startDate,
                        endDate: requestData.endDate,
                        empCode: userCode,
                        empName: empName,
                        payRate: timeReportEmpResp[j].pay_Rate,
                        totalWorkingHours: Math.round((timeReportEmpResp[j].totalEmployeeWorkingHours) * 100) / 100 + 'hrs'
                    };


                    let particularEmpData = [];
                    for (let m = 0; m < timeReportEmpDetailsResp.length; m++) {

                        const startDate = new Date(timeReportEmpDetailsResp[m].date); // Replace with your start date
                        const newDateForm = startDate.getDate();
                        const month = startDate.toLocaleString('default', { month: 'short' });
                        const formattedDate = startDate.getDate().toString().padStart(2, '0') + ' ' + month;

                        // let day = new Date(timeReportEmpDetailsResp[m].date).getDate();
                        let workHours = timeReportEmpDetailsResp[m].totalHours;
                        const attributeName = formattedDate; // Generate attribute name based on index
                        const attributeValue = workHours + 'hrs'; // Get value from array
                        object[attributeName] = attributeValue; // Assign value to object attribute

                        let newObj = {
                            workDate: newDateForm,
                            workHours: workHours
                        }

                        particularEmpData.push(newObj);
                        object['particularEmpData'] = particularEmpData;
                    }
                    break;
                }
            }
            empTableData.push(object);
        }

        //---------------

        //get School or Department Name using its id
        // const deptOrSchoolResp = await DataStore.query(Schools, (c) => c.id.eq(requestData.schoolOrDeptId));
        // const deptOrSchoolResp = await graphQLFindRecordById("getSchools", requestData.schoolOrDeptId)

        const deptOrSchoolResp = schoolAllList.find(o => o.id === requestData.schoolOrDeptId)

        if (deptOrSchoolResp) {
            //set Data for View Popup
            let obj = {
                requestDataId: requestData.id,
                account: requestData.account,
                schoolOrDeptId: deptOrSchoolResp.name,
                dailyRate: requestData.dailyRate,
                status: requestData.status,
                hourlyRate: requestData.hourlyRate,
                type: requestData.type,
                period: requestData.period,
                startDate: requestData.startDate,
                endDate: requestData.endDate,
                authorizingBoardReportDate: requestData.authorizingBoardReportDate,
                pageNo: requestData.pageNo,
                Notes: requestData?.Notes,
                // approvalFinalData: approvalFinalData
                empTableData: empTableData
            }
            console.log("check45");
            var datesArr = [];
            var monthArr = [];
            var current = moment(empTableData[0].startDate);
            monthArr.push(current.format('MM'));
            var end = moment(empTableData[0].endDate);
            var templength = [];
            //datesLength[current.format('MM')] = 1
            while (current <= end) {
                datesArr.push(current.format('YYYY-MM-DD'));
                templength.push(current.format('YYYY-MM-DD'));
                if (!monthArr.includes(current.format('MM'))) {
                    monthArr.push(current.format('MM'));
                    templength = []
                    templength.push(current.format('YYYY-MM-DD'));
                } else {
                    datesLength[current.format('MM')] = templength.length
                }

                current.add(1, 'days');
            }
            dates = datesArr
            months = monthArr

            const currentDate = new Date(empTableData[0].startDate);
            const lastDate = new Date(empTableData[0].endDate);
            console.log(datesLength)
            setDatesLength(datesLength)
            setLatestMonths(months)
            setLatestDates(dates)

            getData(requestData.id, currentDate, lastDate, datesLength, months, dates);

            setSpecificReportDetailsView(obj);
        }
        setPosition(position);
        setVisible(true);

    }

    //onclick edit poup
    const onClickRequestedReportEditPopUp = async (requestData) => {

        //------time report-------
        //get specific report employee data for report:-TimeReportEmployee table
        // const timeReportEmpResp = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(requestData.id));
        const timeReportEmpResp = timeReportEmployeesList.filter(e => e.time_Report_Id.includes(requestData.id))


        //fetch user data
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
        let firstName = '', lastName = '';
        users.forEach((user, i) => {

            userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
            userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
            userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
            firstName = user.Attributes.find(attr => attr.Name === "custom:firstName")?.Value;
            lastName = user.Attributes.find(attr => attr.Name === "custom:lastName")?.Value;
            userName = userName ? userName : firstName + " " + lastName;

            let obj = {
                "userId": sub,
                "name": userName,
                "email": userEmail,
                "usercode": userCode,
                "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
            }
            newRes.push(obj);
        }
        );

        let empData = [];
        let empTableData = [];

        for (let j = 0; j < timeReportEmpResp.length; j++) {

            //particular employee get details data
            // const timeReportEmpDetailsResp = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmpResp[j].id));
            const timeReportEmpDetailsResp = timeReportEmployeeDetailsList.filter(e => e.time_Report_Employee_Id.includes(timeReportEmpResp[j].id))

            let object = {};
            for (let i = 0; i < newRes.length; i++) {
                const currentItem = newRes[i];
                const cognito = new AWS.CognitoIdentityServiceProvider();

                // if (currentItem.userId === timeReportEmpResp[j].employee_Id) {

                empData.push(currentItem);
                // var employeeResponses1 = await DataStore.query(Employee, timeReportEmpResp[j].employee_Id);
                var employeeResponses1 = await graphQLFindRecordById("getEmployee", timeReportEmpResp[j].employee_Id)

                let empName = ''
                let userCode = ''
                if (employeeResponses1) {
                    empName = employeeResponses1.employee_name;
                    userCode = employeeResponses1.employee_code
                }

                object = {
                    startDate: requestData.startDate,
                    endDate: requestData.endDate,
                    empCode: userCode,
                    empName: empName,
                    payRate: timeReportEmpResp[j].pay_Rate,
                    totalWorkingHours: Math.round((timeReportEmpResp[j].totalEmployeeWorkingHours) * 100) / 100 + 'hrs'
                };
                for (let m = 0; m < timeReportEmpDetailsResp.length; m++) {

                    const startDate = new Date(timeReportEmpDetailsResp[m].date); // Replace with your start date
                    const month = startDate.toLocaleString('default', { month: 'short' });
                    const formattedDate = startDate.getDate().toString().padStart(2, '0') + ' ' + month;

                    // let day = new Date(timeReportEmpDetailsResp[m].date).getDate();
                    let workHours = timeReportEmpDetailsResp[m].totalHours;

                    const attributeName = formattedDate; // Generate attribute name based on index
                    const attributeValue = workHours + 'hrs'; // Get value from array

                    object[attributeName] = attributeValue; // Assign value to object attribute

                }

                break;
                // }
            }

            empTableData.push(object);
        }

        //---------------

        // const deptOrSchoolResp = await DataStore.query(Schools, (c) => c.id.eq(requestData.schoolOrDeptId));
        const deptOrSchoolResp = await graphQLFindRecordById("getSchools", requestData.schoolOrDeptId)

        if (deptOrSchoolResp) {
            let obj = {
                id: requestData.id,
                account: requestData.account,
                schoolOrDeptId: deptOrSchoolResp.name,
                dailyRate: requestData.dailyRate,
                status: requestData.status,
                hourlyRate: requestData.hourlyRate,
                type: requestData.type,
                Notes: requestData?.Notes,
                period: requestData.period,
                startDate: requestData.startDate,
                endDate: requestData.endDate,
                authorizingBoardReportDate: requestData.authorizingBoardReportDate,
                pageNo: requestData.pageNo,
                empTableData: empTableData
                // approvalFinalData: approvalFinalData
            }
            // if (finalData) {
            var datesArr = [];
            var monthArr = [];
            var current = moment(empTableData[0]?.startDate);
            monthArr.push(current.format('MM'));
            var end = moment(empTableData[0]?.endDate);
            var templength = [];
            //datesLength[current.format('MM')] = 1
            while (current <= end) {
                datesArr.push(current.format('YYYY-MM-DD'));
                templength.push(current.format('YYYY-MM-DD'));
                if (!monthArr.includes(current.format('MM'))) {
                    monthArr.push(current.format('MM'));
                    templength = []
                    templength.push(current.format('YYYY-MM-DD'));
                } else {
                    datesLength[current.format('MM')] = templength.length
                }

                current.add(1, 'days');
            }
            dates = datesArr
            months = monthArr

            const currentDate = new Date(empTableData[0]?.startDate);
            const lastDate = new Date(empTableData[0]?.endDate);
            console.log(datesLength)
            setDatesLength(datesLength)
            setLatestMonths(months)
            setLatestDates(dates)

            getData(requestData.id, currentDate, lastDate, datesLength, months, dates);
            // }
            setSpecificReportDetailsEdit(obj);
        }




        setVisibleRequestedReportEdit(true);

        //check specific report =>transaction cycle length is greter than 3
        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();
            //1.fetch those request which initiate by logged user
            // const particularReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle,
            //     (c) => c.report_Id.eq(requestData.id),
            //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
            // );

            let particularReportTransactionCycleResponse = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(requestData.id))
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            if (particularReportTransactionCycleResponse) {
                //form history related code start.
                let transactionArray = [];
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();

                        } catch (e) {
                            console.log(e)
                        }

                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let fullName = userLastName + " " + userFirstName;


                        let empTitle = '';
                        if (requestData.firstApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Principal/ Dept Head';
                        }
                        else if (requestData.budgetClerk == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Clerk';
                        }
                        else if (requestData.secondApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Manager';
                        } else if (requestData.payrollID == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Payroll';
                        }

                        if (i == 0) {
                            let initiatorUsers;

                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: requestData.initiatorId,
                                }).promise();
                            } catch (e) {
                                console.log(e)
                            }

                            let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            let initiatorFullName = userLastName1 + " " + userFirstName1;


                            let obj = {
                                empName: initiatorFullName,
                                empTitle: 'Initiator',
                                status: 'Submitted',
                                date: particularReportTransactionCycleResponse[i].createdAt ? handleDateSelect(particularReportTransactionCycleResponse[i].createdAt) : handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt)

                            }
                            transactionArray.push(obj);
                        }

                        let obj = {
                            empName: fullName,
                            status: (particularReportTransactionCycleResponse[i].status == 'Open') ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status,
                            empTitle: empTitle,
                            date: (particularReportTransactionCycleResponse[i].status != 'Open') ? (particularReportTransactionCycleResponse[i].customUpdatedAt ? handleDateSelect(particularReportTransactionCycleResponse[i].customUpdatedAt) : handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt)) : '-'
                        }
                        transactionArray.push(obj);
                    }
                }


                setEvents(transactionArray);

                console.log("transactionArraytransactionArray:-", transactionArray);

                //form history related code end.
            }

        } catch (err) {
            console.log(err)
        }
        console.log('Request Report edit')


    }

    //* onclick view popup
    const onClickRequestedReportViewPopup = async (requestData, position) => {
        setViewEmployeeDetailsData([])



        const cognito = new AWS.CognitoIdentityServiceProvider();

        //set transaction cycle data
        try {
            // const particularReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle,
            //     (c) => c.report_Id.eq(requestData.id),
            //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
            // );

            let particularReportTransactionCycleResponse = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(requestData.id))
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            if (particularReportTransactionCycleResponse) {
                let transactionArray = [];
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();

                        } catch (e) {
                            console.log(e)
                        }

                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
                        let fullName = userLastName + " " + userFirstName;


                        let empTitle = '';
                        if (requestData.firstApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Principal/ Dept Head';
                        }
                        else if (requestData.budgetClerk == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Clerk';
                        }
                        else if (requestData.secondApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Manager';
                        } else if (requestData.payrollID == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Payroll';
                        }

                        if (i == 0) {
                            let initiatorUsers;

                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: requestData.initiatorId,
                                }).promise();
                            } catch (e) {
                                console.log(e)
                            }

                            let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            let userCodeEmp1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:userCode") : ''
                            let initiatorFullName = userLastName1 + " " + userFirstName1;

                            let obj = {
                                empName: initiatorFullName,
                                empTitle: 'Initiator',
                                empCode: userCodeEmp1,
                                status: 'Submitted',
                                date: particularReportTransactionCycleResponse[i].createdAt ? handleDateSelect(particularReportTransactionCycleResponse[i].createdAt) : null
                            }
                            transactionArray.push(obj);
                        }

                        let obj = {
                            empName: fullName,
                            empCode: userCodeEmp,
                            status: (particularReportTransactionCycleResponse[i].status == 'Open') ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status,
                            empTitle: empTitle,
                            // date: particularReportTransactionCycleResponse[i].customUpdatedAt ? handleDateSelect(particularReportTransactionCycleResponse[i].customUpdatedAt) : null
                            date: (particularReportTransactionCycleResponse[i].status != 'Open') ? (particularReportTransactionCycleResponse[i].customUpdatedAt ? handleDateSelect(particularReportTransactionCycleResponse[i].customUpdatedAt) : handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt)) : '-'

                            // updatedAt:appDate,
                            // isApproved: particularReportTransactionCycleResponse[i].isApproved,                            
                            //status: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? 'Completed' : (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover[0].status) == 'PENDING' ? 'Pending' : statusReport)),
                            //status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
                        }
                        transactionArray.push(obj);
                    }
                }
                setEvents(transactionArray);
            }


        } catch (err) {
            console.log(err)
        }

        //get specific report employee data for report:-TimeReportEmployee table
        // const timeReportEmpResp = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(requestData.id));
        const timeReportEmpResp = timeReportEmployeesList.filter(e => e.time_Report_Id.includes(requestData?.id))

        //fetch user data
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '';
        let sub = '';
        let firstName = '';
        let lastName = '';
        users.forEach((user, i) => {

            userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
            userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
            userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
            firstName = user.Attributes.find(attr => attr.Name === "custom:firstName")?.Value;
            lastName = user.Attributes.find(attr => attr.Name === "custom:lastName")?.Value;
            userName = userName ? userName : firstName + " " + lastName
            //
            let obj = {
                "userId": sub,
                "name": userName,
                "email": userEmail,
                "usercode": userCode,
                "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
            }
            newRes.push(obj);
        }
        );

        let empData = [];
        let empTableData = [];

        for (let j = 0; j < timeReportEmpResp.length; j++) {

            //particular employee get details data
            // const timeReportEmpDetailsResp = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmpResp[j].id));
            const timeReportEmpDetailsResp = timeReportEmployeeDetailsList.filter(e => e.time_Report_Employee_Id.includes(timeReportEmpResp[j].id))

            let object = {};
            // var employeeResponses1 = await DataStore.query(Employee, timeReportEmpResp[j].employee_Id);
            var employeeResponses1 = await graphQLFindRecordById("getEmployee", timeReportEmpResp[j].employee_Id)

            let empName = ''
            let userCode = ''
            if (employeeResponses1) {
                empName = employeeResponses1.employee_name;
                userCode = employeeResponses1.employee_code
            }
            for (let i = 0; i < newRes.length; i++) {
                const currentItem = newRes[i];

                if (timeReportEmpResp[j].employee_Id) {
                    empData.push(currentItem);

                    object = {
                        startDate: requestData.startDate,
                        endDate: requestData.endDate,
                        empCode: userCode,
                        empName: empName,
                        payRate: timeReportEmpResp[j].pay_Rate,
                        // totalWorkingHours: timeReportEmpResp[j].totalEmployeeWorkingHours + 'hrs'
                        totalWorkingHours: Math.round((timeReportEmpResp[j].totalEmployeeWorkingHours) * 100) / 100 + 'hrs'
                    };
                    for (let m = 0; m < timeReportEmpDetailsResp.length; m++) {

                        const startDate = new Date(timeReportEmpDetailsResp[m].date); // Replace with your start date
                        const month = startDate.toLocaleString('default', { month: 'short' });
                        const formattedDate = startDate.getDate().toString().padStart(2, '0') + ' ' + month;

                        // let day = new Date(timeReportEmpDetailsResp[m].date).getDate();
                        let workHours = timeReportEmpDetailsResp[m].totalHours;

                        const attributeName = formattedDate; // Generate attribute name based on index
                        const attributeValue = workHours + 'hrs'; // Get value from array

                        object[attributeName] = attributeValue; // Assign value to object attribute

                    }

                    break;
                }
            }

            empTableData.push(object);

        }

        //---------------
        //setPosition(position);
        //setVisible(true);


        // const deptOrSchoolResp = await DataStore.query(Schools, (c) => c.id.eq(requestData.schoolOrDeptId));
        const deptOrSchoolResp = await graphQLFindRecordById("getSchools", requestData.schoolOrDeptId)

        if (deptOrSchoolResp) {
            let obj = {
                requestDataId: requestData.id,
                account: requestData.account,
                schoolOrDeptId: deptOrSchoolResp.name,
                dailyRate: requestData.dailyRate,
                status: requestData.status,
                hourlyRate: requestData.hourlyRate,
                type: requestData.type,
                period: requestData.period,
                Notes: requestData?.Notes,
                authorizingBoardReportDate: requestData.authorizingBoardReportDate,
                pageNo: requestData.pageNo,
                // approvalFinalData: approvalFinalData
                empTableData: empTableData
            }
            console.log("check Requested Report view popup");
            var datesArr = [];
            var monthArr = [];
            var current = moment(empTableData[0]?.startDate);
            monthArr.push(current.format('MM'));
            var end = moment(empTableData[0]?.endDate);
            var templength = [];
            //datesLength[current.format('MM')] = 1
            while (current <= end) {
                datesArr.push(current.format('YYYY-MM-DD'));
                templength.push(current.format('YYYY-MM-DD'));
                if (!monthArr.includes(current.format('MM'))) {
                    monthArr.push(current.format('MM'));
                    templength = []
                    templength.push(current.format('YYYY-MM-DD'));
                } else {
                    datesLength[current.format('MM')] = templength.length
                }

                current.add(1, 'days');
            }
            dates = datesArr
            months = monthArr

            const currentDate = new Date(empTableData[0]?.startDate);
            const lastDate = new Date(empTableData[0]?.endDate);
            console.log(datesLength)
            setDatesLength(datesLength)
            setLatestMonths(months)
            setLatestDates(dates)
            getData(requestData.id, currentDate, lastDate, datesLength, months, dates);
            setSpecificReportDetailsView(obj);
        }
        setPosition(position);
        setVisible(true);
    }

    const openSidebar = () => {
        // setVisible(true);
        console.log("success");
    }

    const onClickPayrollViewPopup = async (requestData, position) => {

        //get specific report employee data for report:-TimeReportEmployee table
        // const timeReportEmpResp = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(requestData.id));
        const timeReportEmpResp = timeReportEmployeesList.filter(e => e.time_Report_Id.includes(requestData.id))

        //fetch user data
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '', sub;
        users.forEach((user, i) => {

            userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
            userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
            userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

            let obj = {
                "userId": sub,
                "name": userName,
                "email": userEmail,
                "usercode": userCode,
                "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
            }
            newRes.push(obj);
        }
        );

        let empData = [];
        let empTableData = [];

        for (let j = 0; j < timeReportEmpResp.length; j++) {

            //particular employee get details data
            // const timeReportEmpDetailsResp = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmpResp[j].id));
            const timeReportEmpDetailsResp = timeReportEmployeeDetailsList.filter(e => e.time_Report_Employee_Id.includes(timeReportEmpResp[j].id))

            // const cognito = new AWS.CognitoIdentityServiceProvider();

            // let firstApproval;
            // if (timeReportEmpResp[j].employee_Id) {
            // try {
            // firstApproval = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: timeReportEmpResp[j].employee_Id, }).promise();
            // } catch (e) {
            // console.log(e)
            // }
            // }

            // let name1 = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "name") : ''
            // let userFirstName = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "custom:firstName") : ''
            // let userLastName = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "custom:lastName") : ''
            // let userCodeEmp = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "custom:userCode") : ''
            // let fullName = name1 ? name1 : userFirstName + " " + userLastName

            // var employeeResponses1 = await DataStore.query(Employee, timeReportEmpResp[j].employee_Id);
            var employeeResponses1 = await graphQLFindRecordById("getEmployee", timeReportEmpResp[j].employee_Id)

            let empName = ''
            let userCode = ''
            if (employeeResponses1) {
                empName = employeeResponses1.employee_name;
                userCode = employeeResponses1.employee_code
            }
            let object = {};
            for (let i = 0; i < newRes.length; i++) {
                const currentItem = newRes[i];

                if (timeReportEmpResp[j].employee_Id) {
                    empData.push(currentItem);

                    object = {
                        startDate: requestData.startDate,
                        endDate: requestData.endDate,
                        empCode: userCode,
                        empName: empName,
                        payRate: timeReportEmpResp[j].pay_Rate,
                        // totalWorkingHours: timeReportEmpResp[j].totalEmployeeWorkingHours + 'hrs'
                        totalWorkingHours: Math.round((timeReportEmpResp[j].totalEmployeeWorkingHours) * 100) / 100 + 'hrs'
                    };
                    for (let m = 0; m < timeReportEmpDetailsResp.length; m++) {

                        const startDate = new Date(timeReportEmpDetailsResp[m].date); // Replace with your start date
                        const month = startDate.toLocaleString('default', { month: 'short' });
                        const formattedDate = startDate.getDate().toString().padStart(2, '0') + ' ' + month;
                        // let day = new Date(timeReportEmpDetailsResp[m].date).getDate();
                        let workHours = timeReportEmpDetailsResp[m].totalHours;
                        const attributeName = formattedDate; // Generate attribute name based on index
                        const attributeValue = workHours + 'hrs'; // Get value from array
                        object[attributeName] = attributeValue; // Assign value to object attribute

                    }

                    break;
                }
            }

            empTableData.push(object);
        }

        //---------------
        setPosition(position);



        // const deptOrSchoolResp = await DataStore.query(Schools, (c) => c.id.eq(requestData.schoolOrDeptId));
        const deptOrSchoolResp = await graphQLFindRecordById("getSchools", requestData.schoolOrDeptId)

        if (deptOrSchoolResp) {
            let obj = {
                requestDataId: requestData.id,

                account: requestData.account,
                schoolOrDeptId: deptOrSchoolResp.name,
                dailyRate: requestData.dailyRate,
                status: requestData.status,
                hourlyRate: requestData.hourlyRate,
                type: requestData.type,
                period: requestData.period,
                Notes: requestData?.Notes,
                authorizingBoardReportDate: requestData.authorizingBoardReportDate,
                // approvalFinalData: approvalFinalData
                pageNo: requestData.pageNo,
                empTableData: empTableData
            }
            var datesArr = [];
            var monthArr = [];
            var current = moment(empTableData[0].startDate);
            monthArr.push(current.format('MM'));
            var end = moment(empTableData[0].endDate);
            var templength = [];
            //datesLength[current.format('MM')] = 1
            while (current <= end) {
                datesArr.push(current.format('YYYY-MM-DD'));
                templength.push(current.format('YYYY-MM-DD'));
                if (!monthArr.includes(current.format('MM'))) {
                    monthArr.push(current.format('MM'));
                    templength = []
                    templength.push(current.format('YYYY-MM-DD'));
                } else {
                    datesLength[current.format('MM')] = templength.length
                }

                current.add(1, 'days');
            }
            dates = datesArr
            months = monthArr

            const currentDate = new Date(empTableData[0].startDate);
            const lastDate = new Date(empTableData[0].endDate);
            console.log(datesLength)
            setDatesLength(datesLength)
            setLatestMonths(months)
            setLatestDates(dates)
            getData(requestData.id, currentDate, lastDate, datesLength, months, dates);
            setSpecificReportDetailsView(obj);
        }

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();
            //1.fetch those request which initiate by logged user
            // const particularReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle,
            // (c) => c.report_Id.eq(requestData.id),
            // { sort: s => s.createdAt(SortDirection.ASCENDING) }
            // );

            let particularReportTransactionCycleResponse = timeReportTransactionCyclesList.filter(e => e.report_Id === requestData.id)
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));



            if (particularReportTransactionCycleResponse) {
                //form history related code start.
                let transactionArray = [];
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();

                        } catch (e) {
                            //console.log(e)
                        }

                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let fullName = userLastName + " " + userFirstName;


                        let empTitle = '';
                        if (requestData.firstApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Principal/ Dept Head';
                        }
                        else if (requestData.budgetClerk == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Clerk';
                        }
                        else if (requestData.secondApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Manager';
                        } else if (requestData.payrollID == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Payroll';
                        }




                        if (i == 0) {
                            let initiatorUsers;

                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: requestData.initiatorId,
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }

                            let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            let initiatorFullName = userLastName1 + " " + userFirstName1;


                            let obj = {
                                empName: initiatorFullName,
                                empTitle: 'Initiator',
                                status: 'Submitted',
                                date: particularReportTransactionCycleResponse[i].createdAt ? handleDateSelect(particularReportTransactionCycleResponse[i].createdAt) : null

                            }
                            transactionArray.push(obj);
                        }

                        let obj = {
                            empName: fullName,
                            status: (particularReportTransactionCycleResponse[i].status == 'Open') ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status,
                            empTitle: empTitle,
                            date: particularReportTransactionCycleResponse[i].customUpdatedAt ? handleDateSelect(particularReportTransactionCycleResponse[i].customUpdatedAt) : handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt)
                        }
                        transactionArray.push(obj);
                    }
                }

                console.log(transactionArray, "transactionArray")
                setEvents(transactionArray);
                //form history related code end.
            }

        } catch (err) {
            console.log("ERROR in request Edit function");
        }
        console.log("setVisible")
        setVisible(true)
    }

    const onClickPayrollEditPopUp = async (requestData) => {

        //------time report-------

        //-------------------------------------------------------------------------------------------------------
        //get specific report employee data for report:-TimeReportEmployee table
        // const timeReportEmpResp = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(requestData.id));
        const timeReportEmpResp = timeReportEmployeesList.filter(e => e.time_Report_Id.includes(requestData.id))

        //fetch user data
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
        users.forEach((user, i) => {

            userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
            userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
            userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

            let obj = {
                "userId": sub,
                "name": userName,
                "email": userEmail,
                "usercode": userCode,
                "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
            }
            newRes.push(obj);
        }
        );

        let empData = [];
        let empTableData = [];

        for (let j = 0; j < timeReportEmpResp.length; j++) {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            //particular employee get details data
            // const timeReportEmpDetailsResp = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmpResp[j].id));
            const timeReportEmpDetailsResp = timeReportEmployeeDetailsList.filter(e => e.time_Report_Employee_Id.includes(timeReportEmpResp[j].id))

            let object = {};
            for (let i = 0; i < newRes.length; i++) {
                const currentItem = newRes[i];

                // if (currentItem.userId === timeReportEmpResp[j].employee_Id) {
                empData.push(currentItem);

                // let firstApproval;
                // if (timeReportEmpResp[j].employee_Id) {
                // try {
                // firstApproval = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: timeReportEmpResp[j].employee_Id, }).promise();
                // } catch (e) {
                // console.log(e)
                // }
                // }
                // let name1 = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "name") : ''
                // let userFirstName = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "custom:firstName") : ''
                // let userLastName = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "custom:lastName") : ''
                // let userCodeEmp = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "custom:userCode") : ''
                // let fullName = name1 ? name1 : userFirstName + " " + userLastName

                // var employeeResponses1 = await DataStore.query(Employee, timeReportEmpResp[j].employee_Id);
                var employeeResponses1 = await graphQLFindRecordById("getEmployee", timeReportEmpResp[j].employee_Id)

                let empName = ''
                let userCode = ''
                if (employeeResponses1) {
                    empName = employeeResponses1.employee_name;
                    userCode = employeeResponses1.employee_code
                }
                object = {
                    startDate: requestData.startDate,
                    endDate: requestData.endDate,
                    empCode: userCode,
                    empName: empName,
                    payRate: timeReportEmpResp[j].pay_Rate,
                    totalWorkingHours: Math.round((timeReportEmpResp[j].totalEmployeeWorkingHours) * 100) / 100 + 'hrs'
                };
                for (let m = 0; m < timeReportEmpDetailsResp.length; m++) {

                    const startDate = new Date(timeReportEmpDetailsResp[m].date); // Replace with your start date
                    const month = startDate.toLocaleString('default', { month: 'short' });
                    const formattedDate = startDate.getDate().toString().padStart(2, '0') + ' ' + month;
                    // let day = new Date(timeReportEmpDetailsResp[m].date).getDate();
                    let workHours = timeReportEmpDetailsResp[m].totalHours;
                    const attributeName = formattedDate; // Generate attribute name based on index
                    const attributeValue = workHours + 'hrs'; // Get value from array
                    object[attributeName] = attributeValue; // Assign value to object attribute

                }

                break;
                // }
            }

            empTableData.push(object);
        }

        //---------------

        // const deptOrSchoolResp = await DataStore.query(Schools, (c) => c.id.eq(requestData.schoolOrDeptId));
        const deptOrSchoolResp = await graphQLFindRecordById("getSchools", requestData.schoolOrDeptId)


        if (deptOrSchoolResp) {
            let obj = {
                id: requestData.id,

                account: requestData.account,
                schoolOrDeptId: deptOrSchoolResp.name,
                dailyRate: requestData.dailyRate,
                status: requestData.status,
                hourlyRate: requestData.hourlyRate,
                type: requestData.type,
                period: requestData.period,
                startDate: requestData.startDate,
                Notes: requestData?.Notes,
                endDate: requestData.endDate,
                authorizingBoardReportDate: requestData.authorizingBoardReportDate,
                pageNo: requestData.pageNo,
                empTableData: empTableData
                // approvalFinalData: approvalFinalData
            }
            var datesArr = [];
            var monthArr = [];
            var current = moment(empTableData[0]?.startDate);
            monthArr.push(current.format('MM'));
            var end = moment(empTableData[0]?.endDate);
            var templength = [];
            //datesLength[current.format('MM')] = 1
            while (current <= end) {
                datesArr.push(current.format('YYYY-MM-DD'));
                templength.push(current.format('YYYY-MM-DD'));
                if (!monthArr.includes(current.format('MM'))) {
                    monthArr.push(current.format('MM'));
                    templength = []
                    templength.push(current.format('YYYY-MM-DD'));
                } else {
                    datesLength[current.format('MM')] = templength.length
                }

                current.add(1, 'days');
            }
            dates = datesArr
            months = monthArr

            const currentDate = new Date(empTableData[0]?.startDate);
            const lastDate = new Date(empTableData[0]?.endDate);
            console.log(datesLength)
            setDatesLength(datesLength)
            setLatestMonths(months)
            setLatestDates(dates)
            getData(requestData.id, currentDate, lastDate, datesLength, months, dates);
            setSpecificReportDetailsEdit(obj);
        }
        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();
            //1.fetch those request which initiate by logged user
            // const particularReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle,
            // (c) => c.report_Id.eq(requestData.id),
            // { sort: s => s.createdAt(SortDirection.ASCENDING) }
            // );

            let particularReportTransactionCycleResponse = timeReportTransactionCyclesList.filter(e => e.report_Id === requestData.id)
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            if (particularReportTransactionCycleResponse) {
                //form history related code start.
                let transactionArray = [];
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';
                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            //console.log(e)
                        }
                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let fullName = userLastName + " " + userFirstName;
                        let empTitle = '';
                        if (requestData.firstApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Principal/ Dept Head';
                        }
                        else if (requestData?.budgetClerk == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Clerk';
                        }

                        else if (requestData?.secondApprover == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Manager';
                        } else if (requestData.payrollID == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Payroll';
                        }
                        if (i == 0) {
                            let initiatorUsers;
                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: requestData.initiatorId,
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }
                            let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            let initiatorFullName = userLastName1 + " " + userFirstName1;
                            let obj = {
                                empName: initiatorFullName,
                                empTitle: 'Initiator',
                                status: 'Submitted',
                                date: particularReportTransactionCycleResponse[i].createdAt ? handleDateSelect(particularReportTransactionCycleResponse[i].createdAt) : null
                            }
                            transactionArray.push(obj);
                        }
                        let obj = {
                            empName: fullName,
                            status: (particularReportTransactionCycleResponse[i].status == 'Open') ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status,
                            empTitle: empTitle,
                            date: (particularReportTransactionCycleResponse[i].status != 'Open') ? (particularReportTransactionCycleResponse[i].customUpdatedAt ? handleDateSelect(particularReportTransactionCycleResponse[i].customUpdatedAt) : handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt)) : '-'
                        }
                        transactionArray.push(obj);
                    }
                }
                setEvents(transactionArray);
                //form history related code end.
            }
        } catch (err) {
            console.log("ERROR in request Edit function");
        }

        setVisiblePayrollEdit(true);

    }

    const [layout, setLayout] = useState('list');

    const listItem = (product) => {
        return (
            <div className="col-12">
                <DataTable
                    className="custpaginator custIcons custmBtnTable custTable popUpTable"
                    scrollable
                    value={product.data}
                    paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                    emptyMessage="No customers found."
                >
                    <Column field="empCode" header="Emp ID" style={{ minWidth: '3rem' }}></Column>
                    <Column field="empName" header="Emp Name" sortable></Column>
                    {/* <Column field="payRate" header="Pay Rate" sortable style={{ minWidth: '5rem' }}></Column> */}
                    <Column field="totalWorkingHours" header="Total Working Hrs" sortable style={{ minWidth: '5rem' }}></Column>
                    {/* <Column field="action" header="Action" align='center' body={initiatorEditPopUpAction} style={{ minWidth: '6rem' }}></Column> */}

                    {/* <Column header="Status" body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="remark" header="Remarks" align='center' style={{ minWidth: '6rem' }}></Column> */}
                </DataTable>
            </div>
        );
    };

    const gridItem = (product) => {

        let finalData = product.data;

        const dates = [];

        const currentDate = new Date(finalData[0]?.startDate);
        const lastDate = new Date(finalData[0]?.endDate);

        // const currentDate = new Date(specificReportDetailsView.startDate);
        // const lastDate = new Date(specificReportDetailsView.endDate);
        while (currentDate <= lastDate) {

            // let formattedDate = currentDate.getDate();

            const month = currentDate.toLocaleString('default', { month: 'short' });
            const formattedDate = currentDate.getDate().toString().padStart(2, '0') + ' ' + month;

            // dates.push(new Date(currentDate));
            dates.push(formattedDate);
            currentDate.setDate(currentDate.getDate() + 1);
        }
        // return dates;

        return (
            <div className="overflow-x-auto p-2">
                <DataTable
                    className="custpaginator custIcons custmBtnTable custTable popUpTable"
                    scrollable
                    // value={specificReportDetailsView.empTableData}
                    value={product.data}
                    paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={5}

                    // dataKey="srNo" filters={filters} globalFilterFields={['assignmentTitle', 'submittedOn', 'status', 'remark']}
                    // header={header}

                    emptyMessage="No customers found."
                >
                    <Column field="empCode" header="Emp ID" sortable style={{ minWidth: '3rem' }}></Column>
                    <Column field="empName" header="Emp Name" sortable></Column>
                    {/* <Column field="payRate" header="Pay Rate/Hr" sortable style={{ minWidth: '5rem' }}></Column>  */}
                    {

                        dates.map((currentItem) => {

                            return (
                                <Column field={`${(currentItem === "" || currentItem === null ? "-" : currentItem)}`} header={currentItem} sortable style={{ minWidth: '5rem' }}></Column>
                            );

                        })

                    }
                    <Column field="totalWorkingHours" header="Total Hrs" sortable style={{ minWidth: '5rem' }} alignFrozen="right" frozen={true}></Column>
                    {/* <Column field="action" header="Action" align='center' body={initiatorEditPopUpAction} style={{ minWidth: '6rem' }} alignFrozen="right" frozen={true}></Column> */}
                </DataTable>
            </div>
        );
    };
    const itemTemplate = (product, layout) => {

        if (!product) {
            return;
        }

        if (layout === 'list') return listItem(product);
        else if (layout === 'grid') return gridItem(product);

    };

    const header = () => {
        return (
            <div className='flex justify-between'>
                {/* <Link to='#' className="text-center tableBtn blue radius8">
	<i className="gusd-pluse-circle mx-1.5 "></i> Add Employee Time</Link> */}
                <div className="flex justify-content-end">
                    <DataViewLayoutOptions layout={layout} onChange={(e) => setLayout(e.value)} />
                </div>
            </div>

        );
    };

    const toggleActive = () => {
        setActivate(activate === "actives" ? "" : "actives");
    };

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateAllRoleExceptAdmin()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
            console.log(e)
        }
    }

    const saveBasicInfo = async (type) => {

        if (assighnmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
        else if (selectedEmployee === null) { toast.error('Please Select Employee Id'); return; }
        else if (schoolSelect === '') { toast.error('Please Select Assignment At'); return; }
        else if (startDate === null) { toast.error('Please enter From Date'); return; }
        else if (endDate === null) { toast.error('Please enter To Date'); return; }
        else if (subjectCode === null) { toast.error('Please enter To Date'); return; }

        //Save Basic Info
        //check type
        if (type === 'save') {

            //first save report in SixthPeriodAssignmentInitiateReport table
            // var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
            //     "assignment_title": assighnmentTitle,
            //     "employee_id": selectedEmployee.code,
            //     "assighment_at": schoolSelect.name,
            //     "from_date": moment(startDate).format("YYYY-MM-DD"),
            //     "to_date": moment(endDate).format("YYYY-MM-DD"),
            //     "subject_area": subjectCode.name,
            //     "total_staffing_allocation": totalStaffingAllocationectedRole,
            //     "account_charged": accountCharge,
            //     "current_fte_utilized": fteUtilized,
            //     "created_by": loggedUserId,
            //     "particular_emp_reporting_manager": selectedReportingManagerEmployee.code
            //     // "status": Request_Status.P,
            // })
            // );

            await API.graphql(
                graphqlOperation(mutations.createSixthPeriodAssignmentInitiateReport, {
                    input: {
                        assignment_title: assighnmentTitle,
                        employee_id: selectedEmployee.code,
                        assighment_at: schoolSelect.name,
                        from_date: moment(startDate).format("YYYY-MM-DD"),
                        to_date: moment(endDate).format("YYYY-MM-DD"),
                        subject_area: subjectCode.name,
                        total_staffing_allocation: totalStaffingAllocationectedRole,
                        account_charged: accountCharge,
                        current_fte_utilized: fteUtilized,
                        created_by: loggedUserId,
                        particular_emp_reporting_manager: selectedReportingManagerEmployee.code
                    }
                })
            );

            //second add first report transaction entry in SixthPeriodReportTransactionCycle table
            toast.success('Data Added Successfully for pending.');
            BindList();
            setShowNextPopUp(false);

        } else {
            //other wise status submit

            try {

                //first save report in SixthPeriodAssignmentInitiateReport table
                // var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
                //     "assignment_title": assighnmentTitle,
                //     "employee_id": selectedEmployee.code,
                //     "assighment_at": schoolSelect.name,
                //     "from_date": moment(startDate).format("YYYY-MM-DD"),
                //     "to_date": moment(endDate).format("YYYY-MM-DD"),
                //     "subject_area": subjectCode.name,
                //     "total_staffing_allocation": totalStaffingAllocationectedRole,
                //     "account_charged": accountCharge,
                //     "current_fte_utilized": fteUtilized,
                //     "submited_by": loggedUserId,
                //     "created_by": loggedUserId,
                //     "submited_at": moment().format("YYYY-MM-DD"),
                //     "particular_emp_reporting_manager": selectedReportingManagerEmployee.code
                // })
                // );

                var newSixthPeriodAssignmentInitiateReport = await API.graphql(
                    graphqlOperation(mutations.createSixthPeriodAssignmentInitiateReport, {
                        input: {
                            assignment_title: assighnmentTitle,
                            employee_id: selectedEmployee.code,
                            assighment_at: schoolSelect.name,
                            from_date: moment(startDate).format("YYYY-MM-DD"),
                            to_date: moment(endDate).format("YYYY-MM-DD"),
                            subject_area: subjectCode.name,
                            total_staffing_allocation: totalStaffingAllocationectedRole,
                            account_charged: accountCharge,
                            current_fte_utilized: fteUtilized,
                            submited_by: loggedUserId,
                            created_by: loggedUserId,
                            submited_at: moment().format("YYYY-MM-DD"),
                            particular_emp_reporting_manager: selectedReportingManagerEmployee.code
                        }
                    })
                );

                //second add first report transaction entry in SixthPeriodReportTransactionCycle table
                if (newSixthPeriodAssignmentInitiateReport) {

                    // var newSixthPeriodReportTransactionCycle = await DataStore.save(new SixthPeriodReportTransactionCycle({
                    //     "report_Id": newSixthPeriodAssignmentInitiateReport.data.createSixthPeriodAssignmentInitiateReport.id,
                    //     "from_Employee_Id": loggedUserId,
                    //     "to_Employee_Id": selectedEmployee.code,
                    //     "status": 'Open',
                    //     "isApproved": false,
                    //     "remark": '',
                    //     "date": moment().format("YYYY-MM-DD"),
                    // }))

                    await API.graphql(
                        graphqlOperation(mutations.createSixthPeriodReportTransactionCycle, {
                            input: {
                                report_Id: newSixthPeriodAssignmentInitiateReport.data.createSixthPeriodAssignmentInitiateReport.id,
                                from_Employee_Id: loggedUserId,
                                to_Employee_Id: selectedEmployee.code,
                                status: 'Open',
                                isApproved: false,
                                remark: '',
                                date: moment().format("YYYY-MM-DD"),
                            }
                        })
                    );

                    toast.success('Data Added Successfully for Submitted.');
                    BindList();
                    navigateTo("/time_report");
                }
            } catch (err) {
                console.log(err)
            }
        }
    }

    //onSubmitFunction 
    const onSubmitFunction = async (reportId, employeeID) => {

        try {
            // var newSixthPeriodReportTransactionCycle = await DataStore.save(new SixthPeriodReportTransactionCycle({
            //     "report_Id": reportId,
            //     "from_Employee_Id": loggedUserId,
            //     "to_Employee_Id": employeeID,
            //     "status": 'Reviewed & resubmitted',
            //     "isApproved": false,
            //     "remark": '',
            //     "date": moment().format("YYYY-MM-DD"),
            // }))

            await API.graphql(
                graphqlOperation(mutations.createSixthPeriodReportTransactionCycle, {
                    input: {
                        report_Id: reportId,
                        from_Employee_Id: loggedUserId,
                        to_Employee_Id: employeeID,
                        status: 'Reviewed & resubmitted',
                        isApproved: false,
                        remark: '',
                        date: moment().format("YYYY-MM-DD"),
                    }
                })
            );

            // toast.success('Data Added Successfully for Submitted.');
            BindList();

        } catch (err) {
            console.log(err)
        }
    }

    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    const loadUsers = () => {
        //------------------------------- load users-------------
        const cognito = new AWS.CognitoIdentityServiceProvider();
        var params =
        {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 60
        };
        cognito.listUsers(params, (err, data) => {
            if (err) {

            } else {
                SetUsersList(data.Users);



                var newRes = []
                let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
                (data.Users).forEach((user, i) => {
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

                    let obj = {
                        "userId": sub,
                        "name": userName,
                        "email": userEmail,
                        "usercode": userCode,
                        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                    }
                    newRes.push(obj);
                }
                );



                //get only those users are without admin
                let usersWithoutAdminAndLoggedUser = [];
                const loggedUserId = reactLocalStorage.get('loggedUserId');


                newRes.map((currentItem) => {
                    if (currentItem.role !== 'Admin'
                        && currentItem.userId !== loggedUserId) {
                        usersWithoutAdminAndLoggedUser.push(currentItem);
                    }
                })

                //set employee list
                let finalEmployeeList = [{ name: "No Approval Needed", code: 'no_approval_needed' }];

                usersWithoutAdminAndLoggedUser.map((currentItem) => {
                    let obj = { name: currentItem.name, code: currentItem.userId };
                    finalEmployeeList.push(obj);
                })
                setEmployeeList(finalEmployeeList);


            }
        });
        //-------------------------------------------------------
        getLoggRole();
    }


    const getLoggRole = async () => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        //get logged user role
        let adminUsers = '';
        if (loggedUserId) {
            try {
                adminUsers = await cognito.adminGetUser({
                    UserPoolId: awsmobile.aws_user_pools_id,
                    Username: loggedUserId,
                }).promise();
            } catch (e) {
                console.log(e)
            }
        }
        let loggedUserRole = adminUsers ? adminUsers.UserAttributes.find(attr => attr.Name === "custom:role")?.Value : '';
        let role = loggedUserRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : loggedUserRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : loggedUserRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I
        setUserRole(role)
    }

    const BindList = async () => {

        const loggedUserId = reactLocalStorage.get('loggedUserId');

        try {
            //1.fetch those request which initiate by logged user
            // const timeReportInitiatorResponse = await DataStore.query(TimeReportInitiateReport,(c) => c.Created_By.eq(loggedUserId), { sort: s => s.Created_By_Date(SortDirection.DESCENDING) });
            const cognito = new AWS.CognitoIdentityServiceProvider();

            let timeReportInitiatorResponse = await graphQLGetAllData("listTimeReportInitiateReports",[{ isSoftDelete: { ne: true } }])
            timeReportInitiatorResponse = timeReportInitiatorResponse.sort((b, a) => a.Created_By_Date.localeCompare(b.Created_By_Date));
            // timeReportInitiatorResponse = timeReportInitiatorResponse.filter(item => item.isSoftDelete !== true);

            if (timeReportInitiatorResponse.length > 0) {

                let finalInitiateRequestData = [];
                //let sn = timeReportInitiatorResponse.length
                for (let i = 0; i < timeReportInitiatorResponse.length; i++) {
                    const currentItem = timeReportInitiatorResponse[i];

                    // const startDate = new Date(currentItem.From_Date);
                    // const endDate = new Date(currentItem.To_Date);
                    //set date format
                    const startDate = new Date(moment(currentItem.From_Date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));
                    const endDate = new Date(moment(currentItem.To_Date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));

                    // const dateFormatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });

                    const dateFormatter = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                    const formattedStartDate = dateFormatter.format(startDate);
                    const formattedEndDate = dateFormatter.format(endDate);
                    const period = `${formattedStartDate} to ${formattedEndDate}`;
                    // const submittedDateAWS = new Date(currentItem.Created_By_Date);
                    let status = (currentItem.Status) == 'SUBMITTED' ? 'Submitted' : (currentItem.Status) == 'APPROVAL_ACCEPTED' ? 'Approved' : (currentItem.Status) == 'APPROVAL_REJECTED' ? 'Rejected' : (currentItem.Status) == 'RESUBMITTED' ? 'Reviewed & resubmitted' : 'Pending';
                    let remark = '-';
                    let lastStatus = '';
                    //get data from transaction cycle table for remark
                    // const timeReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle, (c) => c.report_Id.eq(currentItem.id), {
                    //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
                    // });
                    let timeReportTransactionCycleResponse = await graphQLGetAllData("listTimeReportTransactionCycles",[{ report_Id: { eq: currentItem.id } }])
                    // let timeReportTransactionCycleResponse = timeReportTransactionCyclesData.filter(e => e.report_Id.includes(currentItem.id))
                    timeReportTransactionCycleResponse = timeReportTransactionCycleResponse.sort((b, a) => a.createdAt.localeCompare(b.createdAt));


                    if (timeReportTransactionCycleResponse.length > 0) {

                        if (timeReportTransactionCycleResponse[0].remark) {
                            remark = timeReportTransactionCycleResponse[0].remark;

                        }
                        lastStatus = timeReportTransactionCycleResponse[0].status
                    }

                    let deptOrSchoolResp = '';
                    if (currentItem.school_Department_Id) {
                        // deptOrSchoolResp = await DataStore.query(Schools, (c) => c.id.eq(currentItem.school_Department_Id));
                        deptOrSchoolResp = await graphQLFindRecordById("getSchools", currentItem.school_Department_Id)
                    }

                    //set Approved if any status is approved
                    let latestStatus;
                    for (let i = 0; i < timeReportTransactionCycleResponse.length; i++) {
                        if (timeReportTransactionCycleResponse[i].status === "Approved") {
                            status = "Approved";
                            break;
                        }
                        if (timeReportTransactionCycleResponse[i].status === "Closed") {
                            status = "Closed";
                            latestStatus = "Closed";
                            break;
                        }
                        if (timeReportTransactionCycleResponse[i].status === "Rejected") {
                            status = "Rejected";
                            remark = timeReportTransactionCycleResponse[i].remark;
                            break;
                        }
                    }
                    if (currentItem.Status === "PENDING") {
                        latestStatus = "Pending";
                    }
                    if (currentItem.Status === 'RESUBMITTED') {
                        status = 'Reviewed & resubmitted';
                        status = lastStatus === 'Approved' ? "Approved" : status;
                    } else {

                        status = remark && remark !== '-' ? 'Rejected' : status;
                    }
                    //status = lastStatus === 'RESUBMITTED' ? 'Reviewed & resubmitted' : status


                    let adminUsers;
                    let Assignee = "";
                    let assigneeId;
                    if (timeReportTransactionCycleResponse.length) {
                        // const cognito = new AWS.CognitoIdentityServiceProvider();

                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: timeReportTransactionCycleResponse[0].status === "Rejected" && status !== 'Reviewed & resubmitted' ? currentItem.Created_By : timeReportTransactionCycleResponse[0].to_Employee_Id,
                                // timeReportTransactionCycleResponse[0].status === "Rejected" ? currentItem.Created_By : timeReportTransactionCycleResponse[0].to_Employee_Id ,
                                // timeReportTransactionCycleResponse[0].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            //console.log(e)
                        }

                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        Assignee = userFirstName + " " + userLastName

                        assigneeId = timeReportTransactionCycleResponse[0].to_Employee_Id;
                    }

                    let NewAssignee = latestStatus === "Closed" || latestStatus === "Pending" ? "-" : Assignee;
                    // if(period=='01/01/2024 to 01/04/2024'){
                    //     console.log('timeReportTransactionCycleResponse :>> ', timeReportTransactionCycleResponse);
                    //     console.log('Assignee :>> ', Assignee);
                    // }
                    let obj = {
                        id: currentItem.id,
                        srNo: i + 1,
                        period: period,
                        schoolDept: deptOrSchoolResp ? deptOrSchoolResp.name : '',
                        submittedOn: currentItem.Created_By_Date,  //(submittedDateAWS).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),
                        status: status,
                        remark: remark,

                        //popup data
                        startDate: formattedStartDate,
                        endDate: formattedEndDate,
                        account: currentItem.Account,
                        pageNo: currentItem.pageNo,
                        Notes: currentItem?.Notes,
                        schoolOrDeptId: currentItem.school_Department_Id,
                        dailyRate: currentItem.Daily_Rate,
                        hourlyRate: currentItem.Hourly_Rate,
                        type: currentItem.Type,
                        authorizingBoardReportDate: currentItem.Authorizing_Board_Report_Date,

                        //approver data
                        initiatorId: currentItem.Created_By,
                        firstApprover: currentItem.First_Approveal,
                        budgetClerk: currentItem?.validator_id,
                        secondApprover: currentItem?.Second_Approveal,
                        payrollID: currentItem?.payroll_id,
                        Assignee: NewAssignee,
                        assigneeId: assigneeId
                    };


                    //sn = sn -1 

                    finalInitiateRequestData.push(obj);
                }


                /* let submitted = finalInitiateRequestData.filter(item => item.status === "Submitted").length
                setSubmitCount(submitted)

                let approved = finalInitiateRequestData.filter(item => item.status === "Approved").length
                setApprovedCount(approved)
                

                let rejected = finalInitiateRequestData.filter(item => item.status === "Rejected").length
                setRejectCount(rejected) */

                //const sortedData = [...finalInitiateRequestData].sort((a, b) => new Date(b.Created_By_Date) - new Date(a.Created_By_Date));

                setInitiatorReportList(finalInitiateRequestData.filter((data) => data.status != "Pending"))

                if (typeOfUser) {
                    // Check if tr_ReportId matches any id in the array
                    const isMatch = finalInitiateRequestData.filter((data) => data.id === typeOfUser);
                    console.log("isMatch", isMatch)
                    if (isMatch && isMatch[0]?.status === "Rejected") {
                        navigateTo("/timereport/initiatenewreport/:reportId" + isMatch[0]?.id);
                    }
                    else {
                        onClickRequestedReportViewPopup(isMatch[0], 'right')
                        // setVisible(true);
                        // setVisibleRight(true);
                    }
                }
                setReportLoading(false)
            } else {
                setReportLoading(false)
            }
            // const timeReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle, (c) => c.to_Employee_Id.eq(loggedUserId), {
            //     sort: (s) => s.createdAt(SortDirection.ASCENDING)
            // });


            console.log(timeReportTransactionCyclesList, "timeReportTransactionCyclesList")
            let timeReportTransactionCycleResponse = timeReportTransactionCyclesList.filter(e => e.to_Employee_Id && e.to_Employee_Id.includes(loggedUserId))
            timeReportTransactionCycleResponse = timeReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            if (timeReportTransactionCycleResponse.length > 0) {
                setReportLoading(true)
                const distinctReportIds = Object.values(timeReportTransactionCycleResponse.reduce((acc, entry) => {
                    if (!acc[entry.report_Id]) {
                        acc[entry.report_Id] = entry;
                    }
                    return acc;
                }, {}));



                //then find latest entry of particular roleId
                let finalRequestedReportData = [];

                for (let i = 0; i < distinctReportIds.length; i++) {

                    // const timeReportTransactionCycleResponseNew = await DataStore.query(TimeReportTransactionCycle, (c) => c.and(c => [
                    //     c.report_Id.eq(distinctReportIds[i].report_Id),
                    //     c.to_Employee_Id.eq(loggedUserId)
                    // ]), {
                    //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
                    // });

                    let timeReportTransactionCycleResponseNew = timeReportTransactionCyclesList.filter(e => e.report_Id?.includes(distinctReportIds[i].report_Id) && e.to_Employee_Id?.includes(loggedUserId))
                    timeReportTransactionCycleResponseNew = timeReportTransactionCycleResponseNew.sort((b, a) => a.createdAt.localeCompare(b.createdAt));
                    // timeReportTransactionCycleResponseNew = timeReportTransactionCycleResponseNew.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

                    if (timeReportTransactionCycleResponseNew.length > 0) {
                        let latestRecord = timeReportTransactionCycleResponseNew[0];
                        //  get Report Meta data using report id 
                        // const timeReportResponse = await DataStore.query(TimeReportInitiateReport, latestRecord.report_Id);
                        const timeReportResponse = await graphQLFindRecordById("getTimeReportInitiateReport", latestRecord.report_Id)

                        let deptOrSchoolResp = '';
                        if (timeReportResponse) {
                            // deptOrSchoolResp = await DataStore.query(Schools, timeReportResponse.school_Department_Id);
                            deptOrSchoolResp = schoolAllList.find(o => o.id === timeReportResponse.school_Department_Id)

                            // const startDate = new Date(timeReportResponse.From_Date);
                            // const endDate = new Date(timeReportResponse.To_Date);

                            const startDate = new Date(moment(timeReportResponse.From_Date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));
                            const endDate = new Date(moment(timeReportResponse.To_Date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));


                            const dateFormatter = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                            const formattedStartDate = dateFormatter.format(startDate);
                            const formattedEndDate = dateFormatter.format(endDate);
                            const period = `${formattedStartDate} to ${formattedEndDate}`;
                            const submittedDateAWS = new Date(timeReportResponse.Created_By_Date);

                            // let status = (currentItem.isApproved) ? 'Approved' :(timeReportResponse.Status=='R')?'Rejected': 'Pending for Approval';
                            // let status = (timeReportResponse.Status == 'APPROVAL_REJECTED') ? 'Rejected' : (currentItem.isApproved) ? 'Approved' : 'Pending for Approval';
                            let status = (latestRecord.isApproved) ? 'Approved' : (latestRecord.status) == 'Rejected' ? 'Rejected' : 'Pending for Approval';
                            let remark = (latestRecord.remark) ? latestRecord.remark : "-";

                            //check for last status of all cycle 
                            // const finalResponse = await DataStore.query(TimeReportTransactionCycle,
                            //     c => c.report_Id.eq(distinctReportIds[i].report_Id),
                            //     { sort: s => s.createdAt(SortDirection.DESCENDING) }
                            // );

                            let finalResponse = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(distinctReportIds[i].report_Id))
                            finalResponse = finalResponse.sort((b, a) => a.createdAt.localeCompare(b.createdAt));

                            if (finalResponse.length) {
                                status = finalResponse[0].remark && finalResponse[0].status === 'Rejected' ? 'Rejected' : status

                                remark = finalResponse[0].remark && finalResponse[0].status === 'Rejected' ? finalResponse[0].remark : remark
                            }


                            //check payroll user role
                            /*  const cognito = new AWS.CognitoIdentityServiceProvider();
                             let adminUsers = '';
                             if (loggedUserId) {
                                 try {
                                     adminUsers = await cognito.adminGetUser({
                                         UserPoolId: awsmobile.aws_user_pools_id,
                                         Username: loggedUserId,
                                     }).promise();
                                 } catch (e) {
                                     console.log(e)
                                 }
                             }
                             
                             let loggedUserRole = adminUsers ? adminUsers.UserAttributes.find(attr => attr.Name === "custom:role")?.Value : ''; */

                            let role = userloggedRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : loggedUserRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : loggedUserRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I

                            if (role === USER_TYPES_NAMES.P) {
                                status = (latestRecord.status) === 'Open' ? "Open" : "Closed"
                            }



                            let timeReportTransactionCycleResponseAp = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(timeReportResponse.id))
                            timeReportTransactionCycleResponseAp = timeReportTransactionCycleResponseAp.sort((b, a) => a.createdAt.localeCompare(b.createdAt));

                            setIsFormApproved(timeReportTransactionCycleResponseAp[0].status)
                            //assignee column code 

                            let adminUsers;
                            let Assignee = "";
                            if (timeReportTransactionCycleResponseAp.length) {
                                const cognito = new AWS.CognitoIdentityServiceProvider();

                                try {
                                    adminUsers = await cognito.adminGetUser({
                                        UserPoolId: awsmobile.aws_user_pools_id,
                                        Username: timeReportTransactionCycleResponseAp[0].status === "Rejected" ? timeReportResponse.Created_By : timeReportTransactionCycleResponseAp[0].to_Employee_Id,
                                        // Username: (finalResponse[finalResponse.length - 1].status == 'REJECTED' ? finalResponse[finalResponse.length - 1].from_Employee_Id : finalResponse[finalResponse.length - 1].to_Employee_Id)
                                        // (reportTransactionCycles[reportTransactionCycles.length - 1].status == 'REJECTED' ? loggedUserId : reportTransactionCycles[reportTransactionCycles.length - 1].to_Employee_Id)
                                    }).promise();
                                } catch (e) {
                                    //console.log(e)
                                }

                                let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                                let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                                Assignee = userFirstName + " " + userLastName

                            }


                            let NewAssignee1 = status === "Closed" || timeReportTransactionCycleResponseAp[0].status === "Closed" ? "-" : Assignee;


                            let obj = {
                                id: timeReportResponse.id,
                                srNo: i + 1,
                                period: period,
                                schoolDept: deptOrSchoolResp ? deptOrSchoolResp.name : '',
                                // submittedOn: timeReportResponse.Created_By_Date,
                                submittedOn: timeReportResponse.Created_By_Date,  //(submittedDateAWS).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),
                                status: status,
                                remark: remark,
                                //popup data
                                startDate: formattedStartDate,
                                endDate: formattedEndDate,
                                account: timeReportResponse.Account,
                                pageNo: timeReportResponse.pageNo,
                                schoolOrDeptId: timeReportResponse.school_Department_Id,
                                dailyRate: timeReportResponse.Daily_Rate,
                                hourlyRate: timeReportResponse.Hourly_Rate,
                                Notes: timeReportResponse?.Notes,
                                type: timeReportResponse.Type,
                                authorizingBoardReportDate: timeReportResponse.Authorizing_Board_Report_Date,
                                //approver data
                                initiatorId: timeReportResponse.Created_By,
                                firstApprover: timeReportResponse.First_Approveal,
                                budgetClerk: timeReportResponse?.validator_id,
                                secondApprover: timeReportResponse?.Second_Approveal,
                                payrollID: timeReportResponse?.payroll_id,
                                Assignee: NewAssignee1,
                            };

                            finalRequestedReportData.push(obj);
                        }
                    }
                }

                /* let pendingForApproval = finalRequestedReportData.filter(item => item.status === "Pending for Approval").length
                setPendingForApprovalCountForReqReports(pendingForApproval)

                let approved = finalRequestedReportData.filter(item => item.status === "Approved").length
                setApprovedCountForReqReports(approved)


                let rejected = finalRequestedReportData.filter(item => item.status === "Rejected").length
                setRejectCountForReqReports(rejected)

                let openCount = finalRequestedReportData.filter(item => item.status === "Open").length
                setOpenCount(openCount)

                let closedCount = finalRequestedReportData.filter(item => item.status === "Closed").length
                setClosedCount(closedCount) */
                let role = userloggedRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : loggedUserRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : loggedUserRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I
                setApprovalReportRequest(finalRequestedReportData);
                if (typeOfUser) {
                    // Check if editReportId matches any id in the array
                    const isMatch = finalRequestedReportData.filter((data) => data.id === typeOfUser);

                    let timeReportTransactionCycleLate = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: typeOfUser } }, { to_Employee_Id: { eq: loggedUserId } }])
                    let isMatchNew = timeReportTransactionCycleLate ? timeReportTransactionCycleLate.sort((a, b) => a.createdAt.localeCompare(b.createdAt)) : [];

                    // console.log("isMatchNew",isMatchNew[isMatchNew.length-1]);

                    if (isMatch && isMatchNew[isMatchNew.length - 1]?.status === "Open" && role === USER_TYPES_NAMES.AP
                    ) {
                        onClickRequestedReportEditPopUp(isMatch[0])
                    }
                    else if (isMatchNew[isMatchNew.length - 1]?.status === "Open" && role === USER_TYPES_NAMES.P) {
                        onClickPayrollEditPopUp(isMatch[0])
                    }
                    else {
                        console.log("err");
                    }
                }

                setReportLoading(false)
            } else {
                setReportLoading(false)
            }


            // if (timeReportTransactionCycleResponse.length > 0) {
            //     // Sort the array in descending order based on reportId and fromEmpId
            //     const sortedData = timeReportTransactionCycleResponse.sort((a, b) => {
            //         if (a.report_Id === b.report_Id) {
            //             return b.to_Employee_Id.localeCompare(a.to_Employee_Id);
            //         }
            //         return b.report_Id - a.report_Id;
            //     });

            //     

            //     // Get the latest entry for each report ID
            //     const latestEntries = Object.values(sortedData.reduce((acc, entry) => {
            //         if (!acc[entry.report_Id]) {
            //             acc[entry.report_Id] = entry;
            //         }
            //         return acc;
            //     }, {}));

            //     
            // }


            // return 0;
            //-------------------------------------------------------

            // if (timeReportTransactionCycleResponse) {

            //     let finalRequestedReportData = [];
            //     for (let i = 0; i < timeReportTransactionCycleResponse.length; i++) {
            //         const currentItem = timeReportTransactionCycleResponse[i];

            //         //  get Report Meta data using report id 
            //         const timeReportResponse = await DataStore.query(TimeReportInitiateReport, (c) => c.id.eq(currentItem.report_Id));
            //         


            //         if (timeReportResponse.length > 0) {
            //             const startDate = new Date(timeReportResponse[0].From_Date);
            //             const endDate = new Date(timeReportResponse[0].To_Date);
            //             // const dateFormatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
            //             const dateFormatter = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });


            //             const formattedStartDate = dateFormatter.format(startDate);
            //             const formattedEndDate = dateFormatter.format(endDate);
            //             const period = `${formattedStartDate} to ${formattedEndDate}`;
            //             const submittedDateAWS = new Date(timeReportResponse[0].Created_By_Date);


            //             // let status = (currentItem.isApproved) ? 'Approved' :(timeReportResponse[0].Status=='R')?'Rejected': 'Pending for Approval';
            //             let status = (timeReportResponse[0].Status == 'APPROVAL_REJECTED') ? 'Rejected' : (currentItem.isApproved) ? 'Approved' : 'Pending for Approval';

            //             let remark = (currentItem.remark) ? currentItem.remark : "-";




            //             //get data from transaction cycle table for remark
            //             const timeReportTransactionCycleResponse = await DataStore.query(TimeReportTransactionCycle, (c) => c.report_Id.eq(timeReportResponse[0].id), {
            //                 sort: (s) => s.createdAt(SortDirection.DESCENDING)
            //             });
            //             if (timeReportTransactionCycleResponse.length > 0) {
            //                 
            //                 

            //                 if (timeReportTransactionCycleResponse[0].remark) {
            //                     remark = timeReportTransactionCycleResponse[0].remark;
            //                 }
            //             }



            //             let obj = {
            //                 id: timeReportResponse[0].id,
            //                 srNo: i + 1,
            //                 period: period,
            //                 // submittedOn: timeReportResponse[0].Created_By_Date,
            //                 submittedOn: (submittedDateAWS).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),

            //                 status: status,
            //                 remark: remark,

            //                 //popup data
            //                 startDate: formattedStartDate,
            //                 endDate: formattedEndDate,
            //                 account: timeReportResponse[0].Account,
            //                 schoolOrDeptId: timeReportResponse[0].school_Department_Id,
            //                 dailyRate: timeReportResponse[0].Daily_Rate,
            //                 hourlyRate: timeReportResponse[0].Hourly_Rate,
            //                 type: timeReportResponse[0].Type,
            //                 authorizingBoardReportDate: timeReportResponse[0].Authorizing_Board_Report_Date
            //             };

            //             finalRequestedReportData.push(obj);
            //         }

            //     }

            //     setApprovalReportRequest(finalRequestedReportData);
            // }

            //-------------------------------------------------------------------------------------
            //2.fetch those request which needs approval for logged users.
            // const sixthPeriodReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.to_Employee_Id.eq(loggedUserId));
            // 

            // if (sixthPeriodReportTransactionCycleResponse) {

            //     let pendingCount = 0;
            //     let approvedCount = 0;
            //     let rejectCount = 0;
            //     let approvalFinalData = [];
            //     for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {
            //         const currentItem = sixthPeriodReportTransactionCycleResponse[i];

            //         //get Report data using report id 
            //         const sixthPeriodReportResponse = await DataStore.query(SixthPeriodAssignmentInitiateReport, (c) => c.id.eq(currentItem.report_Id));
            //         

            //         const sixthPeriodReportTransactionCycleResponseNew = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(currentItem.report_Id));
            //         


            //         const startDate = new Date(sixthPeriodReportResponse[0].from_date);
            //         const endDate = new Date(sixthPeriodReportResponse[0].to_date);
            //         const dateFormatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
            //         const formattedStartDate = dateFormatter.format(startDate);
            //         const formattedEndDate = dateFormatter.format(endDate);
            //         const period = `${formattedStartDate} to ${formattedEndDate}`;
            //         let status = (currentItem.isApproved) ? 'Approved' : (currentItem.remark) ? 'Rejected' : 'Pending for Approval';
            //         let remark = (currentItem.remark) ? currentItem.remark : "-";

            //         // if (sixthPeriodReportTransactionCycleResponseNew) {
            //         //     for (let i = 0; i < sixthPeriodReportTransactionCycleResponseNew.length; i++) {

            //         //         // if(){

            //         //         // }


            //         //         if (sixthPeriodReportTransactionCycleResponseNew[i].remark) {
            //         //             remark = sixthPeriodReportTransactionCycleResponseNew[i].remark;
            //         //             status = "Rejected";
            //         //         }
            //         //     }
            //         // }


            //         let obj = {
            //             id: sixthPeriodReportResponse[0].id,
            //             srNo: i + 1,
            //             assignmentTitle: sixthPeriodReportResponse[0].assignment_title,
            //             period: period,
            //             submittedOn: sixthPeriodReportResponse[0].submited_at,
            //             status: status,
            //             remark: remark,

            //             //data for pdf 
            //             // employeeName: 'Empoyee NAme',
            //             employeeCode: sixthPeriodReportResponse[0].employee_id,
            //             assignmentAt: sixthPeriodReportResponse[0].assighment_at,
            //             toDate: sixthPeriodReportResponse[0].to_date,
            //             fromDate: sixthPeriodReportResponse[0].from_date,
            //             subjectData: sixthPeriodReportResponse[0].subject_area,
            //             totalStaffAllocation: sixthPeriodReportResponse[0].total_staffing_allocation,
            //             accountCharged: sixthPeriodReportResponse[0].account_charged,
            //             currentFTEUtilized: sixthPeriodReportResponse[0].current_fte_utilized
            //         };

            //         //specific report category get approved,submitted and rejected count

            //         if (status === 'Pending For Approval') {
            //             pendingCount++;
            //         } else if (status === 'Approved') {
            //             approvedCount++;
            //         } else if (status === 'Rejected') {
            //             rejectCount++;
            //         }

            //         approvalFinalData.push(obj);
            //     }

            //     approvalFinalData.reverse();

            //     setPendingForApprovalCountForReqReports(pendingCount);
            //     setApprovedCountForReqReports(approvedCount);
            //     setRejectCountForReqReports(rejectCount);
            //     setApprovalReportRequest(approvalFinalData);
            // }

        } catch (err) {
            console.log(err)
            setReportLoading(false)
        }


        // var SubjectCodeResponses = await DataStore.query(Subject, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });
        // setSubjectCodeList(SubjectCodeResponses)
        // var myArray = []; myArray = ConvertResponseForSelectWithRefCodedropdown(SubjectCodeResponses); setSubjectListDropdown(myArray);


        // var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });


    }


    const convertArrayOfObjectsToCSV = (data) => {
        const csvRows = [];
        const headers = Object.keys(data[0]);

        csvRows.push(headers.join(','));

        for (const row of data) {
            const values = headers.map((header) => row[header]);
            csvRows.push(values.join(','));
        }

        return csvRows.join('\n');
    };

    const downloadCSV = (data, filename) => {
        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };


    const exportFilteredDataToCSVApprover = (fileName) => {


        const dataToExport = approvalReportRequestList.map(({ srNo, schoolDept, schoolOrDeptId, account, authorizingBoardReportDate, dailyRate, startDate, endDate, hourlyRate, period, remark, status, submittedOn, type }) => ({
            "SI No": srNo, "School Department": schoolDept, "School or Dept ID": schoolOrDeptId, "Account": account, "Submitted On": submittedOn, "Authorizing Board Report Date": authorizingBoardReportDate, "Status": status, "Remark": remark, "Daily Rate": dailyRate,
            "Start Date": startDate, "End Date": endDate, "Hourly rate": hourlyRate, "Period": period, "Type": type
        }));

        const csvData = convertArrayOfObjectsToCSV(dataToExport);
        downloadCSV(csvData, fileName);

    };


    const exportFilteredDataToCSV = (fileName) => {


        const dataToExport = initiatorReportList.map(({ srNo, schoolDept, schoolOrDeptId, account, authorizingBoardReportDate, dailyRate, startDate, endDate, hourlyRate, period, remark, status, submittedOn, type }) => ({
            "SI No": srNo, "School Department": schoolDept, "School or Dept ID": schoolOrDeptId, "Account": account, "Submitted On": submittedOn, "Authorizing Board Report Date": authorizingBoardReportDate, "Status": status, "Remark": remark, "Daily Rate": dailyRate,
            "Start Date": startDate, "End Date": endDate, "Hourly rate": hourlyRate, "Period": period, "Type": type
        }));

        const csvData = convertArrayOfObjectsToCSV(dataToExport);
        downloadCSV(csvData, fileName);

    };

    //initiate new report
    const initiateNewReport = async () => {

        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '', userReportingManager = '', sub = '';

        users.forEach((user, i) => {
            userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
            userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
            userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
            userReportingManager = user.Attributes.find(attr => attr.Name === "custom:SPReportingManager")?.Value;

            let obj = {
                "userId": sub,
                "name": userName,
                "email": userEmail,
                "usercode": userCode,
                "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                "userReportingManager": userReportingManager
            }
            newRes.push(obj);
        }
        );

        //get only those users are without admin
        let usersWithoutAdmin = [];
        const loggedUserId = reactLocalStorage.get('loggedUserId');


        newRes.map((currentItem) => {
            if (currentItem.role !== 'Admin'
                && currentItem.userId !== loggedUserId) {
                usersWithoutAdmin.push(currentItem);
            }
        })

        //set employee list
        let finalEmpList = [];

        usersWithoutAdmin.map((currentItem) => {
            let obj = { name: currentItem.usercode + '(' + currentItem.name + ')', code: currentItem.userId };
            finalEmpList.push(obj);
        })
        setEmpCodeList(finalEmpList);
        setAllEmployeeDetails(usersWithoutAdmin);

        setShowNextPopUp(true);
    }



    //onSelect particular employye
    const selectedEmployeeFunction = async (e) => {

        //remove specific employee from list
        let newEmpForRM = [];
        for (let i = 0; i < empCodeList.length; i++) {
            if (empCodeList[i].code === e.value.code) {
                continue;
            } else {
                newEmpForRM.push(empCodeList[i]);
            }
        }


        setEmpCodeListForRM(newEmpForRM);

        setSelectedEmployee(e.value);
        //set selected id employee data
        allEmployeeDetails.map((currentItem) => {
            if (currentItem.userId === e.value.code) {
                setSelectedEmployeeDetails(currentItem);

                if (currentItem.userReportingManager) {
                    empCodeList.map((currentItems) => {
                        if (currentItems.code === currentItem.userReportingManager) {
                            setSelectedReportingManagerEmployee(currentItems);
                        }
                    })
                } else {
                    setSelectedReportingManagerEmployee(null);
                }

            }
        })


    }



    //approve report function
    const approveSelectedReport = async (reportId) => {

        // alert("approveSelectedReport")
        try {
            const loggedUserId = reactLocalStorage.get("loggedUserId");

            // const timeReportInitiateReportResponse = await DataStore.query(TimeReportInitiateReport, (c) => c.id.eq(reportId));
            const timeReportInitiateReportResponse = await graphQLFindRecordById("getTimeReportInitiateReport", reportId)

            // const original = await DataStore.query(TimeReportTransactionCycle
            //     , (c) => c.report_Id.eq(reportId), {
            //     sort: (s) => s.createdAt(SortDirection.ASCENDING)
            // }
            // );


            let original = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(reportId))
            original = original.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            // const original = await DataStore.query(TimeReportTransactionCycle,
            //     (c) => c.and(c => [
            //         c.report_Id.eq(reportId),
            //         c.to_Employee_Id.eq(loggedUserId)
            //     ]), {
            //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
            // });

            if (timeReportInitiateReportResponse.First_Approveal === loggedUserId) {
                if (original) {

                    let lastReRecordOriginal1 = original[0];

                    if (timeReportInitiateReportResponse.Status === "RESUBMITTED") {
                        lastReRecordOriginal1 = original[original.length - 1];
                    }


                    const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                    // OLD Data Store Code
                    // await DataStore.save(
                    //     TimeReportTransactionCycle.copyOf(lastReRecordOriginal1, (updated) => {
                    //         updated.isApproved = true;
                    //         updated.status = 'Approved';
                    //         updated.customUpdatedAt = currentDateTime;
                    //     })
                    // ).then(async () => {

                    // const sendToEmployee = timeReportInitiateReportResponse.validator_id ? timeReportInitiateReportResponse.validator_id : timeReportInitiateReportResponse.Second_Approveal ? timeReportInitiateReportResponse.Second_Approveal : timeReportInitiateReportResponse.payroll_id
                    //after we add another row for save report id for reporting managers approver
                    // const addNewRowForSecondAppResponse = await DataStore.save(new TimeReportTransactionCycle({
                    //     "report_Id": reportId,
                    //     "from_Employee_Id": loggedUserId,
                    //     "to_Employee_Id": sendToEmployee,
                    //     "customUpdatedAt": currentDateTime,
                    //     "status": 'Open',
                    //     "isApproved": false,
                    //     "remark": '',
                    //     "date": moment().format("YYYY-MM-DD"),
                    // }));

                    // if (addNewRowForSecondAppResponse) {

                    //     // AP2 to AP3
                    //     await handleNotificationsOnStatusChangeforTimeReport('OPEN', addNewRowForSecondAppResponse.report_Id, "TIME_REPORT", sendToEmployee, loggedUserId);

                    //     setRequestApprovalConfirmVisible(true);
                    //     setCheckedSignature(false);
                    // }
                    // })

                    // const sendToEmployee = timeReportInitiateReportResponse.Second_Approveal ? timeReportInitiateReportResponse.Second_Approveal : timeReportInitiateReportResponse.validator_id ? timeReportInitiateReportResponse.validator_id : timeReportInitiateReportResponse.payroll_id
                    const sendToEmployee = timeReportInitiateReportResponse.validator_id ? timeReportInitiateReportResponse.validator_id : timeReportInitiateReportResponse.payroll_id;


                    await API.graphql({
                        query: mutations.updateTimeReportTransactionCycle,
                        variables: {
                            input: {
                                id: lastReRecordOriginal1.id,
                                _version: lastReRecordOriginal1._version,
                                isApproved: true,
                                status: 'Approved',
                                customUpdatedAt: currentDateTime
                            }
                        }
                    });

                    const addNewRowForSecondAppResponse = await API.graphql(
                        graphqlOperation(mutations.createTimeReportTransactionCycle, {
                            input: {
                                report_Id: reportId,
                                from_Employee_Id: loggedUserId,
                                to_Employee_Id: sendToEmployee,
                                customUpdatedAt: currentDateTime,
                                status: 'Open',
                                isApproved: false,
                                remark: '',
                                date: moment().format("YYYY-MM-DD"),
                            }
                        })
                    );

                    // alert("AP1")

                    await handleNotificationsOnStatusChangeforTimeReport('PAYROLL_ACK', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", sendToEmployee, timeReportInitiateReportResponse.Created_By);
                    // alert("AP2")
                    await handleNotificationsOnStatusChangeforTimeReport('APPROVEDBY', timeReportInitiateReportResponse.id, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, loggedUserId);

                    setRequestApprovalConfirmVisible(true);
                    setCheckedSignature(false);
                }
            }
            else if (timeReportInitiateReportResponse.validator_id == loggedUserId) {
                if (original) {

                    let lastReRecordOriginal1 = original[1];

                    if (timeReportInitiateReportResponse.Status === "RESUBMITTED") {
                        lastReRecordOriginal1 = original[original.length - 1];
                    }


                    const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                    const sendToEmployee = timeReportInitiateReportResponse.Second_Approveal;

                    await API.graphql({
                        query: mutations.updateTimeReportTransactionCycle,
                        variables: {
                            input: {
                                id: lastReRecordOriginal1.id,
                                _version: lastReRecordOriginal1._version,
                                isApproved: true,
                                status: 'Approved',
                                customUpdatedAt: currentDateTime
                            }
                        }
                    });

                    const addNewRowForSecondAppResponse = await API.graphql(
                        graphqlOperation(mutations.createTimeReportTransactionCycle, {
                            input: {
                                report_Id: reportId,
                                from_Employee_Id: loggedUserId,
                                to_Employee_Id: sendToEmployee,
                                customUpdatedAt: currentDateTime,
                                status: 'Open',
                                isApproved: false,
                                remark: '',
                                date: moment().format("YYYY-MM-DD"),
                            }
                        })
                    );

                    // alert("AP1")

                    await handleNotificationsOnStatusChangeforTimeReport('OPEN', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", sendToEmployee, timeReportInitiateReportResponse.Created_By);
                    // alert("AP2")
                    await handleNotificationsOnStatusChangeforTimeReport('APPROVEDBY', timeReportInitiateReportResponse.id, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, loggedUserId);

                    setRequestApprovalConfirmVisible(true);
                    setCheckedSignature(false);
                }
            }


            else if (timeReportInitiateReportResponse.Second_Approveal === loggedUserId) {
                if (original) {

                    if (selectedEmployeeForApprovals) {
                        if (selectedEmployeeForApprovals.code === "no_approval_needed") {

                            let lastReRecordOriginal1 = original[1];

                            if (timeReportInitiateReportResponse.Status === "RESUBMITTED") {
                                lastReRecordOriginal1 = original[original.length - 1];
                            }


                            const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                            // Old Data Store code
                            // await DataStore.save(
                            //     TimeReportTransactionCycle.copyOf(lastReRecordOriginal1, (updated) => {
                            //         updated.isApproved = true;
                            //         updated.status = 'Closed';
                            //         updated.customUpdatedAt = currentDateTime;

                            //     })
                            // ).then(async () => {

                            //     //after we closed we change metadata table =TimeReportInitiateReport status 
                            //     await DataStore.save(
                            //         TimeReportInitiateReport.copyOf(timeReportInitiateReportResponse, (updated) => {
                            //             updated.Status = 'APPROVAL_ACCEPTED';
                            //         })
                            //     ).then(async () => {
                            //         setRequestApprovalConfirmVisible(true);
                            //         setCheckedSignature(false);
                            //     })
                            // })



                            await API.graphql({
                                query: mutations.updateTimeReportTransactionCycle,
                                variables: {
                                    input: {
                                        id: lastReRecordOriginal1.id,
                                        _version: lastReRecordOriginal1._version,
                                        updatedisApproved: true,
                                        updatedstatus: 'Closed',
                                        updatedcustomUpdatedAt: currentDateTime
                                    }
                                }
                            });

                            await API.graphql({
                                query: mutations.updateTimeReportInitiateReport,
                                variables: {
                                    input: {
                                        id: timeReportInitiateReportResponse.id,
                                        _version: timeReportInitiateReportResponse._version,
                                        Status: 'APPROVAL_ACCEPTED'
                                    }
                                }
                            });

                            setRequestApprovalConfirmVisible(true);
                            setCheckedSignature(false);



                        } else {

                            // alert("else 3")

                            const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");



                            //if user select employee for approval then:-
                            // await DataStore.save(
                            //     TimeReportTransactionCycle.copyOf(original[1], (updated) => {
                            //         updated.isApproved = true;
                            //         updated.status = 'Approved';
                            //         updated.customUpdatedAt = currentDateTime;
                            //     })
                            // ).then(async () => {

                            //     //after we add another row for save report id for reporting managers approver
                            //     const addNewRowForSecondAppResponse = await DataStore.save(new TimeReportTransactionCycle({
                            //         "report_Id": reportId,
                            //         "from_Employee_Id": loggedUserId,
                            //         "to_Employee_Id": selectedEmployeeForApprovals.code,
                            //         "status": 'Open',
                            //         "customUpdatedAt": currentDateTime,
                            //         "isApproved": false,
                            //         "remark": '',
                            //         "date": moment().format("YYYY-MM-DD"),
                            //     }));

                            //     if (addNewRowForSecondAppResponse) {
                            //         setRequestApprovalConfirmVisible(true);
                            //         setCheckedSignature(false);
                            //     }
                            // })

                            await API.graphql({
                                query: mutations.updateTimeReportTransactionCycle,
                                variables: {
                                    input: {
                                        id: original[1].id,
                                        _version: original[1]._version,
                                        isApproved: true,
                                        status: 'Approved',
                                        customUpdatedAt: currentDateTime
                                    }
                                }
                            });

                            var addNewRowForSecondAppResponse = await API.graphql(
                                graphqlOperation(mutations.createTimeReportTransactionCycle, {
                                    input: {
                                        report_Id: reportId,
                                        from_Employee_Id: loggedUserId,
                                        to_Employee_Id: selectedEmployeeForApprovals.code,
                                        status: 'Open',
                                        customUpdatedAt: currentDateTime,
                                        isApproved: false,
                                        remark: '',
                                        date: moment().format("YYYY-MM-DD"),
                                    }
                                })
                            );
                            await handleNotificationsOnStatusChangeforTimeReport('OPEN', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", selectedEmployeeForApprovals.code, timeReportInitiateReportResponse.Created_By);

                            await handleNotificationsOnStatusChangeforTimeReport('APPROVEDBY', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, loggedUserId);

                            setRequestApprovalConfirmVisible(true);
                            setCheckedSignature(false);
                        }
                    }
                    else {
                        //check second approval to payroll
                        let lastRecordOriginal1 = original[original.length - 1];


                        const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                        // await DataStore.save(
                        //     TimeReportTransactionCycle.copyOf(lastRecordOriginal1, (updated) => {
                        //         updated.isApproved = true;
                        //         updated.status = 'Approved';
                        //         updated.customUpdatedAt = currentDateTime
                        //     })
                        // ).then(async () => {

                        //     //after we add another row for save report id for reporting managers approver
                        //     const addNewRowForSecondAppResponse = await DataStore.save(new TimeReportTransactionCycle({
                        //         "report_Id": reportId,
                        //         "from_Employee_Id": loggedUserId,
                        //         "to_Employee_Id": timeReportInitiateReportResponse.payroll_id,
                        //         "status": 'Open',
                        //         "isApproved": false,
                        //         "customUpdatedAt": currentDateTime,
                        //         "remark": '',
                        //         "date": moment().format("YYYY-MM-DD"),
                        //     }));

                        //     if (addNewRowForSecondAppResponse) {
                        //         setRequestApprovalConfirmVisible(true);
                        //         setCheckedSignature(false);
                        //     }
                        // })

                        const udpateData = await API.graphql({
                            query: mutations.updateTimeReportTransactionCycle,
                            variables: {
                                input: {
                                    id: lastRecordOriginal1.id,
                                    _version: lastRecordOriginal1._version,
                                    isApproved: true,
                                    status: 'Approved',
                                    customUpdatedAt: currentDateTime
                                }
                            }
                        });


                        var addNewRowForSecondAppResponse = await API.graphql(
                            graphqlOperation(mutations.createTimeReportTransactionCycle, {
                                input: {
                                    report_Id: reportId,
                                    from_Employee_Id: loggedUserId,
                                    to_Employee_Id: timeReportInitiateReportResponse.payroll_id,
                                    status: 'Open',
                                    isApproved: false,
                                    customUpdatedAt: currentDateTime,
                                    remark: '',
                                    date: moment().format("YYYY-MM-DD"),
                                }
                            })
                        );


                        await handleNotificationsOnStatusChangeforTimeReport('OPEN', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", timeReportInitiateReportResponse.payroll_id, timeReportInitiateReportResponse.Created_By);

                        await handleNotificationsOnStatusChangeforTimeReport('APPROVEDBY', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, loggedUserId);

                        setRequestApprovalConfirmVisible(true);
                        setCheckedSignature(false);

                    }
                    //-------------------------------------------------------
                }



            } else if (timeReportInitiateReportResponse.payroll_id === loggedUserId) {
                if (original) {
                    console.log("selectedEmployeeForApprovals", selectedEmployeeForApprovals);
                    if (selectedEmployeeForApprovals) {
                        if (selectedEmployeeForApprovals.code === "no_approval_needed") {
                            const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");


                            // await DataStore.save(
                            //     TimeReportTransactionCycle.copyOf(original[1], (updated) => {
                            //         updated.isApproved = true;
                            //         updated.status = 'Closed';
                            //         updated.customUpdatedAt = currentDateTime;
                            //     })
                            // ).then(async () => {

                            //     //after we closed we change metadata table =TimeReportInitiateReport status 
                            //     await DataStore.save(
                            //         TimeReportInitiateReport.copyOf(timeReportInitiateReportResponse, (updated) => {
                            //             updated.Status = 'APPROVAL_ACCEPTED';
                            //         })
                            //     ).then(async () => {
                            //         setRequestApprovalConfirmVisible(true);
                            //         setCheckedSignature(false);
                            //     })
                            // })

                            await API.graphql({
                                query: mutations.updateTimeReportTransactionCycle,
                                variables: {
                                    input: {
                                        id: original[1].id,
                                        _version: original[1]._version,
                                        isApproved: true,
                                        status: 'Closed',
                                        customUpdatedAt: currentDateTime
                                    }
                                }
                            });

                            await API.graphql({
                                query: mutations.updateTimeReportInitiateReport,
                                variables: {
                                    input: {
                                        id: timeReportInitiateReportResponse.id,
                                        _version: timeReportInitiateReportResponse._version,
                                        Status: 'APPROVAL_ACCEPTED'
                                    }
                                }
                            });

                            await handleNotificationsOnStatusChangeforTimeReport('ACKNOWLEDGE', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", selectedEmployeeForApprovals.code, timeReportInitiateReportResponse.Created_By);

                            setRequestApprovalConfirmVisible(true);
                            setCheckedSignature(false);


                        }
                        else {
                            const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                            //if user select employee for approval then:-
                            // await DataStore.save(
                            //     TimeReportTransactionCycle.copyOf(original[1], (updated) => {
                            //         updated.isApproved = true;
                            //         updated.status = 'Approved';
                            //         updated.customUpdatedAt = currentDateTime;
                            //     })
                            // ).then(async () => {

                            //     //after we add another row for save report id for reporting managers approver
                            //     const addNewRowForSecondAppResponse = await DataStore.save(new TimeReportTransactionCycle({
                            //         "report_Id": reportId,
                            //         "from_Employee_Id": loggedUserId,
                            //         "to_Employee_Id": selectedEmployeeForApprovals.code,
                            //         "status": 'Open',
                            //         "customUpdatedAt": currentDateTime,
                            //         "isApproved": false,
                            //         "remark": '',
                            //         "date": moment().format("YYYY-MM-DD"),
                            //     }));

                            //     if (addNewRowForSecondAppResponse) {
                            //         setRequestApprovalConfirmVisible(true);
                            //         setCheckedSignature(false);
                            //     }
                            // })

                            await API.graphql({
                                query: mutations.updateTimeReportTransactionCycle,
                                variables: {
                                    input: {
                                        id: original[1].id,
                                        _version: original[1]._version,
                                        isApproved: true,
                                        status: 'Approved',
                                        customUpdatedAt: currentDateTime
                                    }
                                }
                            });

                            var addNewRowForSecondAppResponse = await API.graphql(
                                graphqlOperation(mutations.createTimeReportTransactionCycle, {
                                    input: {
                                        report_Id: reportId,
                                        from_Employee_Id: loggedUserId,
                                        to_Employee_Id: selectedEmployeeForApprovals.code,
                                        status: 'Open',
                                        customUpdatedAt: currentDateTime,
                                        isApproved: false,
                                        remark: '',
                                        date: moment().format("YYYY-MM-DD"),
                                    }
                                })
                            );
                            await handleNotificationsOnStatusChangeforTimeReport('OPEN', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", selectedEmployeeForApprovals.code, timeReportInitiateReportResponse.Created_By);
                            setRequestApprovalConfirmVisible(true);
                            setCheckedSignature(false);

                        }
                    } else {
                        await handleNotificationsOnStatusChangeforTimeReport('ACKNOWLEDGE', reportId, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, timeReportInitiateReportResponse.payroll_id);

                    }
                    //-------------------------------------------------------
                }
            }
            // else if (timeReportInitiateReportResponse.validator_id === loggedUserId) {
            //     if (original) {

            //         if (selectedEmployeeForApprovals) {
            //             if (selectedEmployeeForApprovals.code === "no_approval_needed") {


            //                 const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

            //                 // await DataStore.save(
            //                 //     TimeReportTransactionCycle.copyOf(original[1], (updated) => {
            //                 //         updated.isApproved = true;
            //                 //         updated.status = 'Closed';
            //                 //         updated.customUpdatedAt = currentDateTime
            //                 //     })
            //                 // ).then(async () => {

            //                 //     //after we closed we change metadata table =TimeReportInitiateReport status 
            //                 //     await DataStore.save(
            //                 //         TimeReportInitiateReport.copyOf(timeReportInitiateReportResponse, (updated) => {
            //                 //             updated.Status = 'APPROVAL_ACCEPTED';
            //                 //         })
            //                 //     ).then(async () => {
            //                 //         setRequestApprovalConfirmVisible(true);
            //                 //         setCheckedSignature(false);
            //                 //     })
            //                 // })

            //                 await API.graphql({
            //                     query: mutations.updateTimeReportTransactionCycle,
            //                     variables: {
            //                         input: {
            //                             id: original[1].id,
            //                             _version: original[1]._version,
            //                             isApproved: true,
            //                             status: 'Closed',
            //                             customUpdatedAt: currentDateTime
            //                         }
            //                     }
            //                 });

            //                 await API.graphql({
            //                     query: mutations.updateTimeReportInitiateReport,
            //                     variables: {
            //                         input: {
            //                             id: timeReportInitiateReportResponse.id,
            //                             _version: timeReportInitiateReportResponse._version,
            //                             Status: 'APPROVAL_ACCEPTED'
            //                         }
            //                     }
            //                 });

            //                 setRequestApprovalConfirmVisible(true);
            //                 setCheckedSignature(false);

            //             } else {

            //                 const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

            //                 //if user select employee for approval then:-
            //                 // await DataStore.save(
            //                 //     TimeReportTransactionCycle.copyOf(original[1], (updated) => {
            //                 //         updated.isApproved = true;
            //                 //         updated.status = 'Approved';
            //                 //         updated.customUpdatedAt = currentDateTime;
            //                 //     })
            //                 // ).then(async () => {

            //                 //     //after we add another row for save report id for reporting managers approver
            //                 //     const addNewRowForSecondAppResponse = await DataStore.save(new TimeReportTransactionCycle({
            //                 //         "report_Id": reportId,
            //                 //         "from_Employee_Id": loggedUserId,
            //                 //         "to_Employee_Id": selectedEmployeeForApprovals.code,
            //                 //         "status": 'Open',
            //                 //         "isApproved": false,
            //                 //         "remark": '',
            //                 //         "customUpdatedAt": currentDateTime,
            //                 //         "date": moment().format("YYYY-MM-DD"),
            //                 //     }));

            //                 //     if (addNewRowForSecondAppResponse) {
            //                 //         setRequestApprovalConfirmVisible(true);
            //                 //         setCheckedSignature(false);
            //                 //     }
            //                 // })

            //                 await API.graphql({
            //                     query: mutations.updateTimeReportTransactionCycle,
            //                     variables: {
            //                         input: {
            //                             id: original[1].id,
            //                             _version: original[1]._version,
            //                             isApproved: true,
            //                             status: 'Approved',
            //                             customUpdatedAt: currentDateTime
            //                         }
            //                     }
            //                 });

            //                 var addNewRowForSecondAppResponse = await API.graphql(
            //                     graphqlOperation(mutations.createTimeReportTransactionCycle, {
            //                         input: {
            //                             report_Id: reportId,
            //                             from_Employee_Id: loggedUserId,
            //                             to_Employee_Id: selectedEmployeeForApprovals.code,
            //                             status: 'Open',
            //                             isApproved: false,
            //                             remark: '',
            //                             customUpdatedAt: currentDateTime,
            //                             date: moment().format("YYYY-MM-DD")
            //                         }
            //                     })
            //                 );
            //                 await handleNotificationsOnStatusChangeforTimeReport('OPEN', addNewRowForSecondAppResponse.data.createTimeReportTransactionCycle.report_Id, "TIME_REPORT", selectedEmployeeForApprovals.code, timeReportInitiateReportResponse.Created_By);

            //                 await handleNotificationsOnStatusChangeforTimeReport('APPROVEDBY', timeReportInitiateReportResponse.id, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, loggedUserId);

            //                 setRequestApprovalConfirmVisible(true);
            //                 setCheckedSignature(false);

            //             }
            //         } else {



            //             const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");


            //             //when validator is logged in pass to second approval
            //             let lastRecordOriginal = original[original.length - 1];
            //             // await DataStore.save(
            //             //     TimeReportTransactionCycle.copyOf(lastRecordOriginal, (updated) => {
            //             //         updated.isApproved = true;
            //             //         updated.status = 'Approved';
            //             //         updated.customUpdatedAt = currentDateTime;
            //             //     })
            //             // ).then(async () => {

            //             //     //after we add another row for save report id for reporting managers approver
            //             //     const addNewRowForSecondAppResponse = await DataStore.save(new TimeReportTransactionCycle({
            //             //         "report_Id": reportId,
            //             //         "from_Employee_Id": loggedUserId,
            //             //         "to_Employee_Id": timeReportInitiateReportResponse.Second_Approveal,
            //             //         "status": 'Open',
            //             //         "isApproved": false,
            //             //         "customUpdatedAt": currentDateTime,
            //             //         "remark": '',
            //             //         "date": moment().format("YYYY-MM-DD"),
            //             //     }));

            //             //     if (addNewRowForSecondAppResponse) {
            //             //         setRequestApprovalConfirmVisible(true);
            //             //         setCheckedSignature(false);
            //             //     }
            //             // })

            //             await API.graphql({
            //                 query: mutations.updateTimeReportTransactionCycle,
            //                 variables: {
            //                     input: {
            //                         id: lastRecordOriginal.id,
            //                         _version: lastRecordOriginal._version,
            //                         isApproved: true,
            //                         status: 'Approved',
            //                         customUpdatedAt: currentDateTime
            //                     }
            //                 }
            //             });

            //             await API.graphql(
            //                 graphqlOperation(mutations.createTimeReportTransactionCycle, {
            //                     input: {
            //                         report_Id: reportId,
            //                         from_Employee_Id: loggedUserId,
            //                         to_Employee_Id: timeReportInitiateReportResponse.Second_Approveal,
            //                         status: 'Open',
            //                         isApproved: false,
            //                         customUpdatedAt: currentDateTime,
            //                         remark: '',
            //                         date: moment().format("YYYY-MM-DD"),
            //                     }
            //                 })
            //             );

            //             setRequestApprovalConfirmVisible(true);
            //             setCheckedSignature(false);

            //         }
            //         //-------------------------------------------------------
            //     }
            // } 
            else {

                //when approver is not first and second then execute this code.
                // alert("New User");

                if (original) {

                    if (selectedEmployeeForApprovals) {
                        if (selectedEmployeeForApprovals.code === "no_approval_needed") {

                            let lastRecordOriginal = original[original.length - 1];
                            const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                            // await DataStore.save(
                            //     TimeReportTransactionCycle.copyOf(lastRecordOriginal, (updated) => {
                            //         updated.isApproved = true;
                            //         updated.status = 'Closed';
                            //         updated.customUpdatedAt = currentDateTime;
                            //     })
                            // ).then(async () => {

                            //     //after we closed we change metadata table =TimeReportInitiateReport status 
                            //     await DataStore.save(
                            //         TimeReportInitiateReport.copyOf(timeReportInitiateReportResponse, (updated) => {
                            //             updated.Status = 'APPROVAL_ACCEPTED';
                            //         })
                            //     ).then(async () => {
                            //         setRequestApprovalConfirmVisible(true);
                            //         setCheckedSignature(false);
                            //     })
                            // })


                            await API.graphql({
                                query: mutations.updateTimeReportTransactionCycle,
                                variables: {
                                    input: {
                                        id: lastRecordOriginal.id,
                                        _version: lastRecordOriginal._version,
                                        isApproved: true,
                                        status: 'Closed',
                                        customUpdatedAt: currentDateTime
                                    }
                                }
                            });

                            await API.graphql({
                                query: mutations.updateTimeReportInitiateReport,
                                variables: {
                                    input: {
                                        id: timeReportInitiateReportResponse.id,
                                        _version: timeReportInitiateReportResponse._version,
                                        Status: 'APPROVAL_ACCEPTED'
                                    }
                                }
                            });

                            setRequestApprovalConfirmVisible(true);
                            setCheckedSignature(false);

                        } else {

                            const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
                            //if user select employee for approval then:-
                            let lastRecordOriginal = original[original.length - 1];
                            // await DataStore.save(
                            //     TimeReportTransactionCycle.copyOf(lastRecordOriginal, (updated) => {
                            //         updated.isApproved = true;
                            //         updated.status = 'Approved';
                            //         updated.customUpdatedAt = currentDateTime;
                            //     })
                            // ).then(async () => {

                            //     //after we add another row for save report id for reporting managers approver
                            //     const addNewRowForSecondAppResponse = await DataStore.save(new TimeReportTransactionCycle({
                            //         "report_Id": reportId,
                            //         "from_Employee_Id": loggedUserId,
                            //         "to_Employee_Id": selectedEmployeeForApprovals.code,
                            //         "status": 'Open',
                            //         "customUpdatedAt": currentDateTime,
                            //         "isApproved": false,
                            //         "remark": '',
                            //         "date": moment().format("YYYY-MM-DD"),
                            //     }));

                            //     if (addNewRowForSecondAppResponse) {
                            //         setRequestApprovalConfirmVisible(true);
                            //         setCheckedSignature(false);
                            //     }
                            // })

                            await API.graphql({
                                query: mutations.updateTimeReportTransactionCycle,
                                variables: {
                                    input: {
                                        id: lastRecordOriginal.id,
                                        _version: lastRecordOriginal._version,
                                        isApproved: true,
                                        status: 'Approved',
                                        customUpdatedAt: currentDateTime
                                    }
                                }
                            });

                            await API.graphql(
                                graphqlOperation(mutations.createTimeReportTransactionCycle, {
                                    input: {
                                        report_Id: reportId,
                                        from_Employee_Id: loggedUserId,
                                        to_Employee_Id: selectedEmployeeForApprovals.code,
                                        status: 'Open',
                                        customUpdatedAt: currentDateTime,
                                        isApproved: false,
                                        remark: '',
                                        date: moment().format("YYYY-MM-DD"),
                                    }
                                })
                            );

                            setRequestApprovalConfirmVisible(true);
                            setCheckedSignature(false);

                        }
                    }
                    //-------------------------------------------------------
                }
            }
        } catch (err) {
            console.log(err)
        }
        getMasterData();
        BindList();
        // return 0;
    }



    //reject report function
    const rejectSelectedReport = async (reportId) => {

        // return 0;
        if (rejectMsgValue === "") { toast.error('Please Add Reason For Rejection'); return; }
        //get specific report id transaction table data and add rejected status in specific entry
        try {
            const loggedUserId = reactLocalStorage.get("loggedUserId");

            // const timeReportInitiateReportResponse = await DataStore.query(TimeReportInitiateReport, (c) => c.id.eq(reportId));
            const timeReportInitiateReportResponse = await graphQLFindRecordById("getTimeReportInitiateReport", reportId)

            // const original = await DataStore.query(TimeReportTransactionCycle, (c) => c.report_Id.eq(reportId),
            //     {
            //         sort: (s) => s.createdAt(SortDirection.ASCENDING)
            //     }
            // );

            /* let timeReportInitiatorResponse = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: reportId } }])

            timeReportInitiatorResponse = timeReportInitiatorResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt)); */
            const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
            let original = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(reportId))
            original = original.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            //get last value (latest record) of particular report
            const lastRecord = original.slice(-1)[0];

            if (lastRecord) {
                if (lastRecord.to_Employee_Id === loggedUserId) {
                    // await DataStore.save(
                    //     TimeReportTransactionCycle.copyOf(lastRecord, (updated) => {
                    //         updated.status = 'Rejected';
                    //         updated.remark = rejectMsgValue;
                    //     })
                    // ).then(async () => {
                    //     //after we rejected we change metadata table =TimeReportInitiateReport status 
                    //     await DataStore.save(
                    //         TimeReportInitiateReport.copyOf(timeReportInitiateReportResponse, (updated) => {
                    //             updated.Status = 'APPROVAL_REJECTED';
                    //         })
                    //     ).then(async () => {
                    //         setSendMsg(true);
                    //         await handleNotificationsOnStatusChangeforTimeReport('REJECTED', timeReportInitiateReportResponse.id, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, loggedUserId, rejectMsgValue);

                    //     })
                    // })

                    await API.graphql({
                        query: mutations.updateTimeReportTransactionCycle,
                        variables: {
                            input: {
                                id: lastRecord.id,
                                _version: lastRecord._version,
                                status: 'Rejected',
                                remark: rejectMsgValue,
                                customUpdatedAt: currentDateTime
                            }
                        }
                    });

                    await API.graphql({
                        query: mutations.updateTimeReportInitiateReport,
                        variables: {
                            input: {
                                id: timeReportInitiateReportResponse.id,
                                _version: timeReportInitiateReportResponse._version,
                                Status: 'APPROVAL_REJECTED'
                            }
                        }
                    });

                    setSendMsg(true);
                    await handleNotificationsOnStatusChangeforTimeReport('REJECTED', timeReportInitiateReportResponse.id, "TIME_REPORT", timeReportInitiateReportResponse.Created_By, loggedUserId, rejectMsgValue);

                }
            }


        } catch (err) {
            console.log(err)
        };
        /* setRequestApprovalConfirmVisible(false);
        setRejectVisible(false);
        setVisibleRequestedReportEdit(false); */
        setRejectValueMsg("");
        setSendMsg(true);
        getMasterData();
    }

    //---filter code------
    //const [filters, setFilters] = useState(null);
    //filter code end-----

    const getMasterData = async () => {
        console.log('rejected')
        console.log('isMasterDataLoaded', isMasterDataLoaded)

        let timeReportTransactionCyclesData = await graphQLGetAllData("listTimeReportTransactionCycles")
        setTimeReportTransactionCyclesList(timeReportTransactionCyclesData)
        console.log(timeReportTransactionCyclesData, "timeReportTransactionCyclesData")

        let timeReportEmployeesData = await graphQLGetAllData("listTimeReportEmployees")
        setTimeReportEmployeesList(timeReportEmployeesData)

        let timeReportEmployeeDetailsData = await graphQLGetAllData("listTimeReportEmployeeDetails")
        setTimeReportEmployeeDetailsList(timeReportEmployeeDetailsData)

        let SchoolResponses = await graphQLGetAllData("listSchools");
        SchoolResponses = SchoolResponses.sort((a, b) => a.name.localeCompare(b.name));

        setAllSchoolList(SchoolResponses);

        var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray);

        setIsMasterDataLoaded(true)
        setIsUpdateData(Math.random())
    }

    useEffect(() => {
        if (specificReportDetailsView.requestDataId) {
            openSidebar();
        }
    }, [specificReportDetailsView, specificReportDetailsEdit, finalData]);

    useEffect(() => {
        onLoad();
        getMasterData();
    }, []);

    useEffect(() => {
        loadUsers();
        if (isMasterDataLoaded === true) {
            BindList();
        }
        // if (sixPeriodIsInitiator === 1) {
        //     setActiveIndex(0)
        // }
        // if (sixPeriodIsApprover === 0) {
        //     setActiveIndex(1)
        // }

        let timeReportIsInitiator = reactLocalStorage.get("timeReportIsInitiator");

        let timeReportIsApprover = reactLocalStorage.get("timeReportIsApprover");
        let timeReportIsPayroll = reactLocalStorage.get("timeReportIsPayroll");
        let timeReportIsSuperadmin = reactLocalStorage.get("timeRIsSAdmin");
        setTimeReportIsInitiator(timeReportIsInitiator);
        setTimeReportIsApprover(timeReportIsApprover);
        setTimeReportIsPayroll(timeReportIsPayroll);
        setTimeReportIsSuperadmin(timeReportIsSuperadmin);

        if (timeReportIsSuperadmin == 1) {
            setActiveIndex(0)
        }

        // if (timeReportIsInitiator == 1) {
        //     setActiveIndex(0)
        // }
    }, [isMasterDataLoaded, isUpdateData]);

    const [statuses] = useState(['Approved', 'Rejected', 'Submitted', 'Reviewed & resubmitted', 'Closed']);

    const [statusesApprover] = useState(['Approved', 'Pending for Approval', 'Rejected']);

    const statusItemTemplate = (option) => {
        return <Tag value={option} severity={TaskStatusSL(option)} />;
    };

    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
        );
    };

    const statusRowFilterTemplateApprover = (options) => {
        return (
            <Dropdown value={options.value} options={statusesApprover} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
        );
    };

    const [payrollstatuses] = useState(['Open', 'Closed']);
    const statusPayrollRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={payrollstatuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
        );
    };



    const TimeSubmitted = (rowdata) => {
        const submittedDateAWS = new Date(rowdata.submittedOn);
        return (rowdata.Created_By_Date !== null ? <span> {(submittedDateAWS).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })} </span> : "-");
    }



    const onClickAck = async (reportId) => {
        // alert("ACK")

        // alertify.confirm('Confirmation', 'Do you want to approve?', async function () {
        // const timeReportInitiateReportResponse = await DataStore.query(TimeReportInitiateReport, (c) => c.id.eq(reportId));
        const timeReportInitiateReportResponse = await graphQLFindRecordById("getTimeReportInitiateReport", reportId)

        // const original = await DataStore.query(TimeReportTransactionCycle
        //     , (c) => c.report_Id.eq(reportId), {
        //     sort: (s) => s.createdAt(SortDirection.ASCENDING)
        // }
        // );

        let original = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(reportId))
        original = original.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

        let newOriginal = original.length ? original[original.length - 1] : original[0];

        // await DataStore.save(
        //     TimeReportTransactionCycle.copyOf(newOriginal, (updated) => {
        //         updated.isApproved = true;
        //         updated.status = 'Closed';
        //         updated.customUpdatedAt = moment().format("YYYY-MM-DD HH:mm:ss");
        //     })
        // ).then(async () => {

        //     //after we closed we change metadata table =TimeReportInitiateReport status 
        //     await DataStore.save(
        //         TimeReportInitiateReport.copyOf(timeReportInitiateReportResponse, (updated) => {
        //             updated.Status = 'APPROVAL_ACCEPTED';
        //         })
        //     ).then(async () => {
        //         setVisiblePayrollEdit(false);
        //         //setCheckedSignature(false);
        //     })
        // })


        await API.graphql({
            query: mutations.updateTimeReportTransactionCycle,
            variables: {
                input: {
                    id: newOriginal.id,
                    _version: newOriginal._version,
                    isApproved: true,
                    status: 'Closed',
                    customUpdatedAt: moment().format("YYYY-MM-DD HH:mm:ss")
                }
            }
        });

        await API.graphql({
            query: mutations.updateTimeReportInitiateReport,
            variables: {
                input: {
                    id: timeReportInitiateReportResponse.id,
                    _version: timeReportInitiateReportResponse._version,
                    Status: 'APPROVAL_ACCEPTED'
                }
            }
        });
        approveSelectedReport(reportId);
        setVisiblePayrollEdit(false);
        getMasterData();
        BindList();
        handlePrint();
    }

    return isAuthenticated ? (
        <>
            <Layout pageTitle="Report" activeMenu="SuperAdmin" appId={'TIME_REPORT'} IsSuperadmin={timeReportIsSuperadmin}
                reDirectUrl={"/time_report"} reDirectUrlforSA={"/time_report/SuperAdminDashboard"}>
                <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
                    <div className="flex justify-end visible lg:hidden">
                        <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                        {/* <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-3">
                            <div>
                                <div id={activate} className="bg-[#FFFFFF] rounded-lg box-shadow-1 radius4 p-4 xl:p-[0.833vw] top-5 lg:sticky fixed -left-96 lg:left-0 lg:overflow-hidden lg:h-auto z-10" data-aos="fade-up" data-aos-duration="800">
                                    <div className="flex justify-between text-[#101828] font-medium text-base tracking-[0.02em] xl:text-[0.932vw]">
                                        <p>Forms</p>
                                       
                                    </div>

                                    <div className="mt-4 h-[600px] xl:h-[38vw]  overflow-auto">

                                        <div className="bg-[#0F1E4C]  radius4 p-[16px] xl:p-[0.833vw]">
                                            <h6 className="font-medium text-[16px] text-[#fff] xl:text-[0.833vw] mb-2">Time Report</h6>
                                            {
                                                userloggedRole === USER_TYPES_NAMES.P ?
                                                    <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#EAEFFF] text-[16px] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {openCount}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Open</div>
                                                        </div>
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {closedCount}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Closed</div>
                                                        </div>
                                                        <div></div>
                                                    </div> :
                                                    <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#EAEFFF] text-[16px] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {(activeIndex === 0) ? submitCount : pendingForApprovalCountForReqReportsCount}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">{(activeIndex === 0) ? 'Submitted' : 'Pending For Approvals'}</div>
                                                        </div>
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {(activeIndex === 0) ? approvedCount : approvedCountForReqReportsCount}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Approved </div>
                                                        </div>
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {(activeIndex === 0) ? rejectCount : rejectCountForReqReportsCount}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Rejected</div>
                                                        </div>
                                                    </div>

                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                            <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                                <div className="sm:flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                                    <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">Time Report</p>

                                    <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                                        {/* {userloggedRole !== USER_TYPES_NAMES.P && timeReportIsInitiator && timeReportIsInitiator == 1 ?
                                            <Link to='/timereport/initiatenewreport' className="lg:w-full text-center tableBtn blue radius8">
                                                <i className="gusd-pluse-circle mx-1.5 "></i> Initiate New Report</Link> : null
                                        } */}
                                        {/* {
                                            timeReportIsApprover == 1 ? <Link to="#" onClick={() => { exportFilteredDataToCSVApprover("TimeReportApprover.csv") }} className=" " > <i className="pi pi-download "></i></Link>
                                                : <Link to="#" onClick={() => { exportFilteredDataToCSV("TimeReportInitiator.csv") }} className=" " > <i className="pi pi-download "></i></Link>
                                        } */}
                                        {/* <Link to='#' className="w-full text-center tableBtn blue radius8" onClick={() => initiateNewReport()}>
                                                <i className="gusd-pluse-circle mx-1.5 "></i> Initiate New Report</Link> */}
                                    </div>
                                </div>



                                {
                                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                        {timeReportIsSuperadmin == 1 ?
                                            <TabPanel header="All Reports">
                                                <div className={initiatorReportList.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                                                    <DataTable
                                                        className="custpaginator custIcons custmBtnTable custTable"
                                                        scrollable
                                                        value={initiatorReportList}
                                                        loading={reportLoading}
                                                        paginator rowsPerPageOptions={[10, 20, 30]} filters={filters} filterDisplay="row" responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}

                                                        // dataKey="srNo" filters={filters} globalFilterFields={['assignmentTitle', 'submittedOn', 'status', 'remark']}
                                                        // header={header}
                                                        emptyMessage="No data found."
                                                    >
                                                        <Column field="srNo" header="SL#" style={{ minWidth: '3rem' }}></Column>
                                                        <Column field="period" header="Period" filter filterPlaceholder="Search" sortable></Column>
                                                        <Column field="schoolDept" header="School/Dept" filter filterPlaceholder="Search" sortable></Column>

                                                        <Column field="submittedOn" header="Submitted On" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }} body={TimeSubmitted} ></Column>
                                                        <Column header="Status" field="status" filter filterElement={statusRowFilterTemplate} body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                                                        <Column
                                                            header="Assignee"
                                                            field="Assignee"
                                                            filter
                                                            filterPlaceholder="Search"
                                                            sortable
                                                            style={{ minWidth: "8rem" }}
                                                        ></Column>
                                                        <Column field="remark" header="Remarks" align='center' style={{ minWidth: '6rem' }}></Column>
                                                        <Column field="action" header="Action" frozen alignFrozen="right" align='center'
                                                            body={initiateReportAction}
                                                            style={{ minWidth: '6rem' }}></Column>
                                                    </DataTable>
                                                </div>
                                            </TabPanel>
                                            : null}

                                    </TabView>
                                }



                                <Dialog className="relative reports-popup" visible={visible} position={position}
                                    style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                                    {isLoading ? (
                                        <div className='grid grid-cols-1 gap-4 justify-center'>
                                            <div className="loader" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="grid grid-cols-2 lg:grid-cols-12">
                                            <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">

                                                <div className="p-5">
                                                    <div onClick={() => setVisible(false)} className="py-3">
                                                        <Image src={sideBarRight} alt="user" width="24" height="24" /></div>

                                                    <div className="text-[#113699] text-md lg:text-[0.833vw] font-bold">Glendale Unified School District </div>
                                                    <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Time Report</div>

                                                    <div className="pt-3">
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Account # </div>
                                                            <div className="font-semibold ">{specificReportDetailsView.account}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">School or Department </div>
                                                            <div className="font-semibold ">{specificReportDetailsView.schoolOrDeptId}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Daily Rate </div>
                                                            <div className="font-semibold ">{specificReportDetailsView.dailyRate}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Status </div>
                                                            <Tag severity="" value={specificReportDetailsView.status} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                            {/* <div >Approved</div> */}
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Hourly Rate</div>
                                                            <div className="font-semibold ">{specificReportDetailsView.hourlyRate}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                                            <div className="font-medium">Type </div>
                                                            <div className="font-semibold ">{specificReportDetailsView.type}</div>
                                                        </div>

                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                                            <div className="font-medium">Period </div>
                                                            <div className="font-semibold ">{specificReportDetailsView.period}</div>
                                                        </div>

                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                                            <div className="font-medium">Notes </div>
                                                            <div className="font-semibold ">{specificReportDetailsView?.Notes}</div>
                                                        </div>
                                                    </div>

                                                    {/* {
                                                      (isPrintClick) ? */}
                                                    {/* <div className='border border-[black] py-3'>
                                                              <div className='flex justify-between'>
                                                                  <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf</div>
                                                                  <button onClick={() => { (!fullViewForView) ? setFullViewForView(true) : setFullViewForView(false) }} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>{(!fullViewForView) ? 'View Full Screen' : 'Exit Full Screen'} </button>
                                                              </div>
                                                              <HtmlToPdfTimeReport />
                                                          </div>
                                                          : */}
                                                    <div className="card" style={{ overflow: 'auto' }}>
                                                        <DataView value={[{
                                                            data: specificReportDetailsView.empTableData
                                                        }]} itemTemplate={itemTemplate} layout={layout} header={header()} />
                                                    </div>
                                                    {/* } */}



                                                    <div>
                                                        <div className='grid grid-cols-1 gap-4'>
                                                            <div className="loader">
                                                                <div onClick={printWithDelay} className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                                    <i className="mr-3 gusd-print-outline"></i><span>Print / Download </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <button onClick={handlePrint} className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                          <i className="mr-3 gusd-print-outline"></i><span>Print / Download</span>
                                                      </button> */}

                                                    {/* <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                          <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                                                      </div> */}

                                                    <div style={{ display: "none" }} >
                                                        <div ref={componentRef}
                                                        // className='printTable'
                                                        //  id='divnames'
                                                        >

                                                            <HtmlToPdfTimeReport
                                                                specificReportDetails={specificReportDetailsView}
                                                                viewEmployeeDetailsData={viewEmployeeDetailsData}
                                                                pages={pages}
                                                                allApproverList={allApproverList}
                                                                allRejectionList={allRejectionList}
                                                                submittedBy={submittedBy}
                                                                totalRowspan={totalRowspan}
                                                                dates={latestDates}
                                                                datesLength={latestDatesLength}
                                                                months={latestMonths}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* //-------------------------- */}
                                                    {/* <div>
                                                      <div className='text-center'>
                                                          <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                                                          <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Request For Approval - Sixth Period Teaching Assignment</div>
                                                      </div>
  
                                                      <div className='pt-3'>
                                                          <p>Approval Status</p>
                                                          <div className="py-3 emp-simple-tbl">
                                                              <DataTable
                                                                  className="custpaginator custIcons custmBtnTable custTable"
                                                                  value={specificReportDetailsView.approvalFinalData}
  
                                                              >
                                                                  <Column field="empCode" header="Title"></Column>
                                                                  <Column field="empName" header="Name"></Column>
                                                                  <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                                              </DataTable>
                                                          </div>
                                                      </div>
                                                  </div> */}



                                                    {/* <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">


                                                </div> */}




                                                    {/* <div className='grid grid-cols-2 gap-4'>
                                                      <div className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                          <i className="mr-3 gusd-print-outline"></i><span>Print</span>
                                                      </div>
  
                                                      <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                          <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                                                      </div>
                                                  </div> */}


                                                </div>

                                            </div>
                                            <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">

                                                <div className="p-5">
                                                    <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                                                    <div className="card custTable">

                                                        <Timeline value={events}
                                                            opposite={(item) => <Tag
                                                                severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                                                value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                                                    <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                                                    <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                                                    <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                                                    <div className="text-color-secondary text-[9px] ml-2">{item.date}</div>
                                                                </div>} />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Dialog>



                                {/* edit popup for initiate request start */}
                                < Dialog className="relative reports-popup" visible={visibleEdit} position="right" style={{ width: `${(fullViewEdit) ? '50vw' : '30vw'}` }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleEdit(false)} draggable={false} resizable={false} >
                                    <div className="">
                                        <div className="bg-[#F5F6F7] relative h-screen">
                                            <div className="p-5">
                                                <a to='' onClick={() => setVisibleEdit(false)} className="py-3"><Image
                                                    src={sidebar} alt="user" width="24" height="24" /></a>


                                                {
                                                    (!fullViewEdit) ?
                                                        <div>
                                                            <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                                                            <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                                                            <div className="bg-white px-2 rounded-[8px] mt-3">
                                                                <div className="mb-1">
                                                                    <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                                                    <div className="emp-simple-tbl">
                                                                        <DataTable
                                                                            className="custpaginator custIcons custmBtnTable custTable"
                                                                            value={specificReportDetailsEdit.approvalFinalData}
                                                                        >
                                                                            <Column field="empCode" header="Title"></Column>
                                                                            <Column field="empName" header="Name"></Column>
                                                                            <Column field="status" header="Status" body={approvalStatusBody}></Column>
                                                                        </DataTable>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> : null
                                                }



                                                <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                                                    {
                                                        (!fullViewEdit) ?
                                                            <div className='flex justify-between'>
                                                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period...pdf</div>
                                                                <button onClick={() => setFullViewEdit(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                                                            </div> :
                                                            <div className='flex justify-between'>
                                                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf</div>
                                                                <button onClick={() => setFullViewEdit(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                                                            </div>
                                                    }

                                                    {
                                                        (!fullViewEdit) ?
                                                            <div className="grid grid-cols-1 border border-[red] h-80 overflow-hidden">
                                                                {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                                                <HtmlToPdf
                                                                    data={{
                                                                        'employeeName': specificReportDetailsEdit.employeeName,
                                                                        'employeeId': specificReportDetailsEdit.employee_id,
                                                                        'schoolName': specificReportDetailsEdit.assighment_at,
                                                                        'dateFrom': specificReportDetailsEdit.from_date,
                                                                        'dateTo': specificReportDetailsEdit.to_date,
                                                                        'subjectName': specificReportDetailsEdit.subject_area,
                                                                        'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                                                        'accountCharged': specificReportDetailsEdit.account_charged,
                                                                        'fteUtilized': specificReportDetailsEdit.current_fte_utilized,
                                                                    }}
                                                                />
                                                            </div> :
                                                            <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto' style={{ height: '580px' }}>
                                                                {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                                                <HtmlToPdf
                                                                    data={{
                                                                        'employeeName': specificReportDetailsEdit.employeeName,
                                                                        'employeeId': specificReportDetailsEdit.employee_id,
                                                                        'schoolName': specificReportDetailsEdit.assighment_at,
                                                                        'dateFrom': specificReportDetailsEdit.from_date,
                                                                        'dateTo': specificReportDetailsEdit.to_date,
                                                                        'subjectName': specificReportDetailsEdit.subject_area,
                                                                        'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                                                        'accountCharged': specificReportDetailsEdit.account_charged,
                                                                        'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                                                    }}
                                                                />
                                                            </div>
                                                    }
                                                </div>
                                            </div>



                                            <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                                                <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                                    //  onClick={() => setVisibleCreteReportPopup(false)}
                                                    onClick={() => setConfirmVisible(true)}
                                                ><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link>

                                                <Link to='' className=" text-center flex items-center tableBtn blue radius8"
                                                    //  onClick={() => saveGroupInfo()}
                                                    onClick={() => {
                                                        onSubmitFunction(specificReportDetailsEdit.id, specificReportDetailsEdit.empID)
                                                        setConfirmVisible(true)
                                                    }
                                                    }
                                                ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Submit</Link>

                                            </div>
                                        </div>
                                    </div>
                                </Dialog >

                                {/* confirmation dialog */}
                                <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                                    <p className="m-0 text-[#0487C8]">
                                        <i className='pi pi-check-circle mr-2'></i>
                                        <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                                    </p>
                                </Dialog>
                                {/* edit popup end */}

                                {/* edit popup for requested report start */}

                                <Dialog className="relative reports-popup" visible={visibleRequestedReportEdit} position="right" style={{ width: '50vw' }}
                                    breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleRequestedReportEdit(false)} draggable={false} resizable={false} >
                                    {isLoading ? (
                                        <div className='grid grid-cols-1 gap-4 justify-center'>
                                            <div className="loader" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="grid grid-cols-2 lg:grid-cols-12">
                                            <div className="bg-[#F5F6F7] relative h-screen col-span-1 lg:col-span-8">
                                                <div className="px-5">
                                                    <a to='' onClick={() => setVisibleRequestedReportEdit(false)} className="py-3"><Image
                                                        src={sidebar} alt="user" width="24" height="24" /></a>

                                                    <div className="text-[#113699] text-md lg:text-[0.833vw] font-bold">Glendale Unified School District </div>
                                                    <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Time Report</div>

                                                    <div className="pt-3">
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Account # </div>
                                                            <div className="font-semibold ">{specificReportDetailsEdit.account}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">School or Department </div>
                                                            <div className="font-semibold ">{specificReportDetailsEdit.schoolOrDeptId}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Daily Rate </div>
                                                            <div className="font-semibold ">{specificReportDetailsEdit.dailyRate}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Status </div>
                                                            <Tag severity="" value={specificReportDetailsEdit.status} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                            {/* <div >Approved</div> */}
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Hourly Rate</div>
                                                            <div className="font-semibold ">{specificReportDetailsEdit.hourlyRate}</div>
                                                        </div>
                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Type </div>
                                                            <div className="font-semibold ">{specificReportDetailsEdit.type}</div>
                                                        </div>

                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                            <div className="font-medium">Period </div>
                                                            <div className="font-semibold ">{specificReportDetailsEdit.period}</div>
                                                        </div>

                                                        <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                                            <div className="font-medium">Notes </div>
                                                            <div className="font-semibold ">{specificReportDetailsEdit?.Notes}</div>
                                                        </div>
                                                    </div>


                                                    <div className="card" style={{ overflow: 'auto' }}>


                                                        <DataView value={[{
                                                            data: specificReportDetailsEdit.empTableData

                                                        }]} itemTemplate={itemTemplate} layout={layout} header={header()} />

                                                    </div>


                                                    {/* <div onClick={printWithDelay} className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-print-outline"></i><span>Print / Download </span>
                                                </div>  */}
                                                    <div>
                                                        <div onClick={printWithDelay} className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                            <i className="mr-3 gusd-print-outline"></i><span>Print / Download</span>
                                                        </div>
                                                    </div>
                                                    {/* <div className='grid grid-cols-2 gap-4'>
                                                    <button onClick={handlePrint} className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                        <i className="mr-3 gusd-print-outline"></i><span>Print</span>
                                                    </button>

                                                    <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                        <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                                                    </div>
                                                </div> */}

                                                    <div style={{ display: "none" }} >
                                                        <div ref={componentRef}
                                                        // className='printTable'
                                                        //  id='divnames'
                                                        >
                                                            <HtmlToPdfTimeReport
                                                                specificReportDetails={specificReportDetailsEdit}
                                                                viewEmployeeDetailsData={viewEmployeeDetailsData}
                                                                pages={pages}
                                                                allApproverList={allApproverList}
                                                                allRejectionList={allRejectionList}
                                                                submittedBy={submittedBy}
                                                                totalRowspan={totalRowspan}
                                                                dates={latestDates}
                                                                datesLength={latestDatesLength}
                                                                months={latestMonths}
                                                            />
                                                        </div>
                                                    </div>


                                                    {/* //----------------------------------- */}
                                                    {/* <div>
                                                    <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                                                    <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                                                    <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                                        <div className="mb-1">
                                                            <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                                            <div className="py-3 emp-simple-tbl">
                                                                <DataTable
                                                                    className="custpaginator custIcons custmBtnTable custTable"
                                                                    value={specificReportDetailsEdit.approvalFinalData}
                                                                >
                                                                    <Column field="empCode" header="Title"></Column>
                                                                    <Column field="empName" header="Name"></Column>
                                                                    <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}

                                                </div>


                                                <div className="dialogpoput card hidden">

                                                    {
                                                        (needMoreApprovals) ?
                                                            <div className='flex px-2'>
                                                                <button onClick={() => setShowNeedMoreApprovals(true)}>Need More Approvals ?</button>

                                                                <Dropdown value={selectedEmployeeForApprovals} onChange={(e) => setSelectedEmployeeForApprovals(e.value)} options={employeeList} optionLabel="name"
                                                                    placeholder="Select a City" className="w-full md:w-14rem" />

                                                            </div> : <div></div>
                                                    }

                                                </div>
                                                <div className="grid grid-cols-3 gap-2 p-3 bg-[#F5F6F7]">

                                                    <Link to='#' onClick={() => setVisibleRequestedReportEdit(false)} className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                                    //  onClick={() => setVisibleCreteReportPopup(false)}
                                                    // onClick={() => setConfirmVisible(true)}
                                                    ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                                                    {
                                                        (!checkedSignature) ?
                                                            <Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                                                                //  onClick={() => saveGroupInfo()}
                                                                onClick={() =>
                                                                    setRejectVisible(true)
                                                                }
                                                            ><i className="gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link> :
                                                            <button disabled className=" text-center flex items-center tableBtn bg-[#E4E7EC] border border-[#D0D5DD] radius8"
                                                            ><i className="pi gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</button>
                                                    }


                                                    {

                                                        (!needMoreApprovals) ?
                                                            <button onClick={() => approveSelectedReport(specificReportDetailsEdit.id)} className="text-center flex items-center tableBtn bg-[#006b3c] text-[#ffffff] text-[#039855] border border-[#D0D5DD] radius8"
                                                            ><i className="pi pi-check mr-1 " style={{ fontSize: '1rem' }}></i>Approve</button>
                                                            :

                                                            (selectedEmployeeForApprovals) ?

                                                                (selectedEmployeeForApprovals.code === 'no_approval_needed') ?

                                                                    <button onClick={() => approveSelectedReport(specificReportDetailsEdit.id)} className="text-center flex items-center tableBtn bg-white text-[#039855] border border-[#D0D5DD] radius8"
                                                                    ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Acknowledge</button> :

                                                                    <button onClick={() => approveSelectedReport(specificReportDetailsEdit.id)} className="text-center flex items-center tableBtn bg-[#006b3c] text-[#ffffff] text-[#039855] border border-[#D0D5DD] radius8"
                                                                    ><i className="pi pi-check mr-1 " style={{ fontSize: '1rem' }}></i>Approve</button> :


                                                                (needMoreApprovals) ?
                                                                    <button disabled className=" text-center flex items-center tableBtn bg-[#E4E7EC] border border-[#D0D5DD] radius8"
                                                                    ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Approve</button>
                                                                    :
                                                                    <button onClick={() => approveSelectedReport(specificReportDetailsEdit.id)} className="text-center flex items-center tableBtn bg-[#006b3c] text-[#ffffff] text-[#039855] border border-[#D0D5DD] radius8"
                                                                    ><i className="pi pi-check mr-1  " style={{ fontSize: '1rem' }}></i>Approve</button>
                                                    }

                                                    {/* {
                                                    (!checkedSignature) ?
                                                        <button disabled className=" text-center flex items-center tableBtn bg-[#E4E7EC] border border-[#D0D5DD] radius8"
                                                        ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Approve</button>
                                                        : <button onClick={() => approveSelectedReport(specificReportDetailsEdit.id)} className="text-center flex items-center tableBtn bg-white text-[#039855] border border-[#D0D5DD] radius8"
                                                        ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Approve</button>
                                                } */}


                                                </div>
                                            </div>

                                            <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">

                                                <div className="p-5">
                                                    <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                                                    <div className="card custTable">

                                                        <Timeline value={events}
                                                            opposite={(item) => <Tag
                                                                severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                                                value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                                                    <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                                                    <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                                                    <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                                                    <div className="text-color-secondary text-[9px] ml-2">{item.date}</div>
                                                                </div>} />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Dialog>


                                <Dialog className="relative reports-popup" visible={visiblePayrollEdit} position="right" style={{ width: '50vw' }}
                                    breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisiblePayrollEdit(false)} draggable={false} resizable={false} >
                                    {isLoading ? (
                                        <div className='grid grid-cols-1 gap-4 justify-center'>
                                            <div className="loader" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="">
                                            <div className="bg-[#F5F6F7] relative h-screen">
                                                <div className="bg-[#F5F6F7] grid grid-cols-12 relative">
                                                    <div className="p-5 col-span-1 lg:col-span-8">
                                                        <div className="p-5">
                                                            <a to='' onClick={() => setVisiblePayrollEdit(false)} className="py-3"><Image
                                                                src={sidebar} alt="user" width="24" height="24" /></a>

                                                            <div className="text-[#113699] text-md lg:text-[0.833vw] font-bold">Glendale Unified School District </div>
                                                            <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Time Report</div>

                                                            <div className="pt-3">
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">Account # </div>
                                                                    <div className="font-semibold ">{specificReportDetailsEdit.account}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">School or Department </div>
                                                                    <div className="font-semibold ">{specificReportDetailsEdit.schoolOrDeptId}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">Daily Rate </div>
                                                                    <div className="font-semibold ">{specificReportDetailsEdit.dailyRate}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">Status </div>
                                                                    <Tag severity="" value={specificReportDetailsEdit.status} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                                    {/* <div >Approved</div> */}
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">Hourly Rate</div>
                                                                    <div className="font-semibold ">{specificReportDetailsEdit.hourlyRate}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                                                    <div className="font-medium">Type </div>
                                                                    <div className="font-semibold ">{specificReportDetailsEdit.type}</div>
                                                                </div>

                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                                                    <div className="font-medium">Period </div>
                                                                    <div className="font-semibold ">{specificReportDetailsEdit.period}</div>
                                                                </div>
                                                            </div>


                                                            <div className="card">


                                                                <DataView value={[{
                                                                    data: specificReportDetailsEdit.empTableData
                                                                }]} itemTemplate={itemTemplate} layout={layout} header={header()} />

                                                            </div>


                                                            <div onClick={() => onClickAck(specificReportDetailsEdit.id)} className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                                <i className="mr-3 gusd-print-outline"></i><span>Print / Acknowledge </span>
                                                            </div>

                                                            {/* <div className='grid grid-cols-2 gap-4'>
                                                    <button onClick={handlePrint} className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                        <i className="mr-3 gusd-print-outline"></i><span>Print</span>
                                                    </button>

                                                    <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                        <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                                                    </div>
                                                </div> */}

                                                            <div style={{ display: "none" }} >
                                                                <div ref={componentRef}
                                                                // className='printTable'
                                                                //  id='divnames'
                                                                >
                                                                    <HtmlToPdfTimeReport
                                                                        specificReportDetails={specificReportDetailsEdit}
                                                                        viewEmployeeDetailsData={viewEmployeeDetailsData}
                                                                        pages={pages}
                                                                        allApproverList={allApproverList}
                                                                        allRejectionList={allRejectionList}
                                                                        submittedBy={submittedBy}
                                                                        totalRowspan={totalRowspan}
                                                                        dates={latestDates}
                                                                        datesLength={latestDatesLength}
                                                                        months={latestMonths}
                                                                    />
                                                                </div>
                                                            </div>


                                                            {/* //----------------------------------- */}
                                                            {/* <div>
                                                    <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                                                    <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                                                    <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                                        <div className="mb-1">
                                                            <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                                            <div className="py-3 emp-simple-tbl">
                                                                <DataTable
                                                                    className="custpaginator custIcons custmBtnTable custTable"
                                                                    value={specificReportDetailsEdit.approvalFinalData}
                                                                >
                                                                    <Column field="empCode" header="Title"></Column>
                                                                    <Column field="empName" header="Name"></Column>
                                                                    <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}

                                                        </div>
                                                    </div>
                                                    <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                                                        <div className="p-5">
                                                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>
                                                            <div className="card custTable">
                                                                <Timeline value={events}
                                                                    opposite={(item) => <Tag
                                                                        severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                                                        value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                                                            <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                                                            <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                                                            <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                                                            <div className="text-color-secondary text-[9px] ml-2">{item.date}</div>
                                                                        </div>} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Dialog>






                                <Dialog header="" visible={requestApprovalConfirmVisible} style={{ width: '30vw' }} onHide={() => { setRequestApprovalConfirmVisible(false); setVisibleEdit(false); }} footer={footerContentForReqApproval}>
                                    <p className="m-0 text-[#0487C8] text-center">
                                        <i className='pi pi-check-circle mr-2'></i>
                                        <span className='font-medium text-[18px]'>This report was Approved</span>
                                    </p>
                                </Dialog>

                                {/* Reject dialog */}
                                <Dialog header="Reject Report" visible={rejectVisible} style={{ width: '30vw' }} onHide={() => {
                                    setRejectVisible(false);
                                    // setVisibleEdit(false);
                                }} footer={footerContentForReqReject}>
                                    <div className="m-0">
                                        {
                                            (!sendMsg) ? <>
                                                <div className='font-medium text-[18px] mb-6'>Enter the Reason for Rejection<span className="text-[red] pl-0.2">*</span></div>
                                                <InputText value={rejectMsgValue} placeholder="Enter the Reason for Rejection" onChange={(e) => setRejectValueMsg(e.target.value)} className="w-full" /></>
                                                :
                                                <div className='font-medium text-[18px] text-[#249144] mb-6'>Message Sent Successfully</div>
                                        }

                                    </div>
                                </Dialog>
                                {/* edit popup end */}
                                {/* edit popup for requested report end */}

                            </div>

                            <Sidebar visible={visibleRight} position="right" onHide={() =>
                                setVisibleRight(false)} style={{ width: '35vw' }} className="customesidebar1 responsivepoup">
                                <Editpopup popupstate={() => setVisibleRight(false)}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                    schoolName={schoolName}
                                    reportEmployeeList={reportEmployeeList}
                                    status={status}
                                    reportId={reportId}
                                    // bindList={() => loadAbsenceReport()}
                                    type={"Initior"}
                                />

                            </Sidebar>
                        </div>
                    </div>
                </div >


                {/* popup's */}
                < Dialog className="relative reports-popup" visible={visibleCreteReportPopup} position="right" style={{ width: '30vw' }
                } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleCreteReportPopup(false)} draggable={false} resizable={false} >
                    <div className="">
                        <div className="bg-[#F5F6F7] relative h-screen">
                            <div className="p-5">
                                <a to='' onClick={() => setVisibleCreteReportPopup(false)} className="py-3"><Image
                                    src={sidebar} alt="user" width="24" height="24" /></a>
                                <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                                {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                                <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                    <div className="mb-1">
                                        <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Assignment Title</label>
                                        <div><InputText
                                            value={groupName}
                                            onChange={e => setGroupName(e.target.value)}
                                            id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                                <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center" onClick={() => setVisibleCreteReportPopup(false)}><i className="pi pi-times mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                                <Link to='' className=" text-center flex items-center tableBtn blue radius8" onClick={() => {
                                    setShowNextPopUp(true);
                                    // saveGroupInfo();
                                }}><i className="pi pi-arrow-right mr-1" style={{ fontSize: '1rem' }}></i>Next</Link>

                            </div>
                        </div>
                    </div>
                </Dialog >


                {/* next full popup */}
                < Dialog className="relative reports-popup" visible={showNextPopUp} position="right" style={{ width: '100vw' }
                } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setShowNextPopUp(false)} draggable={false} resizable={false} >


                    {/* <div class="p-10"><a href="#" id="add-family-open-btn"><i class="gusd-edit text-2xl"></i></a></div> */}
                    <div className="fixed z-10 inset-0 overflow-y-auto styled-select" >

                        <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
                            <div className="relative overflow-hidden transform transition-all w-full">
                                <div className="grid grid-cols-12 custmCols">
                                    <div className="col-span-3 h-full sideBarLeft openSideDiv">
                                        <button onClick={() => { setShowPreviewPopUp(false); setShowNextPopUp(false) }} type="button" className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md" id="add-family-cancel-btn"><i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home</button>
                                        <div className="mt-[16px] xl:mt-[0.833vw] text-[#101828] text-[14px] xl:text-[0.633vw] font-normal">GUSD 6th Period Teaching Assignment</div>
                                        <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">Assignment 10102</div>
                                        <div className="mt-[32px] xl:[1.667vw]">
                                            <ul className="sideTabs">
                                                <li><a href="#" onClick={() => setShowPreviewPopUp(false)} className={`${(showPreviewPopUp) ? 'tab-b active ' : 'tab-b active activeCheck'}`} data-id="tab1">
                                                    <i className="gusd-check text-[16px] xl:text-[1.042vw]"></i>
                                                    Basic Info</a></li>
                                                <li><a href="#"
                                                    // onClick={() => 
                                                    // setShowPreviewPopUp(true)
                                                    // }
                                                    className={`${(showPreviewPopUp) ? 'tab-b active activeCheck' : ''}`} data-id="tab2"><i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Preview & Edit</a></li>
                                                {/* <li><a href="javascript:void(0);" class="tab-b" data-id="tab3"><i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Report Options</a></li> */}
                                            </ul>
                                        </div>
                                        <div className="fixed top-0 left-0 openBtn xl:hidden">
                                            <button type="button" className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"><i className="gusd-arrow-line-right"></i></button>
                                        </div>
                                    </div>

                                    <div className="col-span-12 xl:col-span-6 
                  mScrollCstm
                  overflow-auto
                  ">
                                        <div className="tab-c tab-active p-lr-110 pt-10 xl:pt-0" data-id="tab1">
                                            <div className="text-[24px] xl:text-[1.250vw] font-medium">{(showPreviewPopUp) ? 'Preview & Edit' : 'Basic Info'}</div>
                                            <div className="mCustomScrollbar scroll-w-10 max-h-100">
                                                {
                                                    (!showPreviewPopUp) ?
                                                        <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                                                            <form>
                                                                <div className="space-y-[32px] xl:space-y-[1.667vw]">

                                                                    <div className="col">
                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Assignment Title<span className='text-[red] pl-0.2'>*</span></label>
                                                                        <InputText
                                                                            value={assighnmentTitle}
                                                                            onChange={e => setAssighnmentTitle(e.target.value)}
                                                                            id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" />
                                                                        {/* <input onChange={e => setAssighnmentTitle(e.target.value)} type="text" name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Type here" /> */}
                                                                    </div>

                                                                    <div className='grid grid-cols-2 gap-4'>
                                                                        <div>
                                                                            <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Employee ID<span className='text-[red] pl-0.2'>*</span></label>
                                                                            <Dropdown value={selectedEmployee}
                                                                                onChange={(e) => selectedEmployeeFunction(e)} options={empCodeList} optionLabel="name" placeholder="Select a Employee"
                                                                                filter
                                                                                // valueTemplate={selectedCountryTemplate}
                                                                                className="w-full md:w-14rem" />
                                                                        </div>
                                                                        <div>
                                                                            <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Reporting Manager<span className='text-[red] pl-0.2'>*</span></label>

                                                                            {
                                                                                (!selectedEmployee) ?
                                                                                    <Dropdown
                                                                                        disabled
                                                                                        placeholder="Please First Select a Employee"
                                                                                        className="w-full md:w-14rem"
                                                                                    /> :
                                                                                    <Dropdown value={selectedReportingManagerEmployee}
                                                                                        onChange={(e) => {
                                                                                            setSelectedReportingManagerEmployee(e.value);
                                                                                        }} options={empCodeListForRM} optionLabel="name"
                                                                                        placeholder="Select a Employee"
                                                                                        filter
                                                                                        className="w-full md:w-14rem" />
                                                                            }



                                                                        </div>
                                                                    </div>

                                                                    <div className="col">
                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Assignment at<span className='text-[red] pl-0.2'>*</span></label>
                                                                        <Dropdown id="dept" value={schoolSelect}
                                                                            onChange={(e) => {
                                                                                setSelectedSchool(e.target.value)
                                                                            }}
                                                                            options={schoolList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC]" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                                        />
                                                                    </div>

                                                                    <div className="col">
                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Date<span className='text-[red] pl-0.2'>*</span></label>
                                                                        <div className="grid grid-cols-2 gap-4">
                                                                            <div className="relative custp-calender">
                                                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                                                                <div className="card flex justify-content-center">
                                                                                    <Calendar
                                                                                        onChange={(e) => {
                                                                                            setStartDate(e.target.value)
                                                                                        }}
                                                                                        value={startDate}
                                                                                        placeholder="Start Date"
                                                                                        className="w-full h-11" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="relative custp-calender">
                                                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                                                                <div className="card flex justify-content-center">
                                                                                    <Calendar
                                                                                        onChange={(e) => {
                                                                                            setEndDate(e.target.value)
                                                                                        }}
                                                                                        value={endDate}
                                                                                        minDate={startDate}
                                                                                        placeholder="End Date"
                                                                                        className="w-full h-11" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col">
                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Subject Area<span className='text-[red] pl-0.2'>*</span></label>
                                                                        <Dropdown
                                                                            value={subjectCode}
                                                                            onChange={(e) => { setSubjectCodeList(e.target.value) }}
                                                                            options={absentCodeListDropdown}
                                                                            optionLabel="name" placeholder="Select a Subject "
                                                                            className="w-full" />
                                                                    </div>

                                                                    <div className="col">
                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Total Staffing Allocation</label>
                                                                        <input value={totalStaffingAllocationectedRole} onChange={e => setTotalStaffingAllocation(e.target.value)} type="text" name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Type here" />
                                                                    </div>

                                                                    <div className="col">
                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Account Charged</label>
                                                                        <input value={accountCharge} onChange={e => setAccountCharged(e.target.value)} type="text" name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Type here" />
                                                                    </div>

                                                                    <div className="col">
                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Current FTE Utilized</label>
                                                                        <input value={fteUtilized} onChange={e => setFteUtilized(e.target.value)} type="number" name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Type here" />
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div> :
                                                        <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]'>
                                                            {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                                            <HtmlToPdf
                                                                data={{
                                                                    'employeeName': selectedEmployeeDetails.name,
                                                                    'employeeId': selectedEmployee.name,
                                                                    'schoolName': schoolSelect.name,
                                                                    'dateFrom': moment(startDate).format("YYYY-DD-MM"),
                                                                    'dateTo': moment(endDate).format("YYYY-DD-MM"),
                                                                    'subjectName': subjectCode.name,
                                                                    'staffAllocation': totalStaffingAllocationectedRole,
                                                                    'accountCharged': accountCharge,
                                                                    'fteUtilized': fteUtilized
                                                                }}
                                                            />
                                                        </div>
                                                }

                                            </div>

                                            <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                                                <div>
                                                    <a href="#" onClick={() => (showPreviewPopUp) ? setShowPreviewPopUp(false) : null} className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"><i className='gusd-arrow-line-right mr-1'></i>Previous</a>
                                                </div>
                                                <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                                                    <a
                                                        onClick={() => {
                                                            saveBasicInfo('save');
                                                            setShowPreviewPopUp(false);
                                                        }}
                                                        href="javascript:void(0);" className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"><i className='pi pi-save mr-1' style={{ fontSize: '0.8rem' }}></i>Save</a>
                                                    {
                                                        (showPreviewPopUp) ?
                                                            <a href="#"
                                                                onClick={() => {
                                                                    saveBasicInfo('submit');
                                                                    setConfirmVisible2(true)
                                                                    // setShowPreviewPopUp(true)
                                                                }}
                                                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">
                                                                <i className='gusd-check mr-1'></i>Submit</a> :

                                                            <a href="#" onClick={() => {
                                                                //first we check mandatory fields are filled or not

                                                                if (assighnmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
                                                                else if (selectedEmployee === null) { toast.error('Please Select Employee Id'); return; }
                                                                else if (schoolSelect === '') { toast.error('Please Select Assignment At'); return; }
                                                                else if (startDate === null) { toast.error('Please enter From Date'); return; }
                                                                else if (endDate === null) { toast.error('Please enter To Date'); return; }
                                                                else if (subjectCode === null) { toast.error('Please enter To Date'); return; }

                                                                setShowPreviewPopUp(true)
                                                            }} className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">
                                                                <i className='gusd-eye mr-1'></i>Preview</a>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* confirmation dialog */}

                                    <Dialog header="" visible={confirmVisible2} style={{ width: '30vw' }} onHide={() => { setConfirmVisible2(false); setVisibleEdit(false); }} footer={footerContent1}>
                                        <p className="m-0 text-[#0487C8]">
                                            <i className='pi pi-check-circle mr-2'></i>
                                            <span className='font-medium text-[18px]'>This report Has been Successfully  Created</span>
                                        </p>
                                    </Dialog>

                                    <div className="col-span-3 sideBarRight openSideDiv">
                                        <div className="h-full relative">
                                            <div className="text-[24px] xl:text-[1.250vw] font-medium">Employee Details</div>
                                            <div className="mt-[15px] lg:mt-[32px] xl:[1.667vw]">

                                                {
                                                    (selectedEmployee) ?
                                                        <div className='bg-[#D8E7FC] border border-[#D8E7FC] grid grid-cols-12 gap-4'>
                                                            <Avatar className='col-span-3' image="/images/avatar/amyelsner.png" size="xlarge" shape="circle" />
                                                            <div className='col-span-7'>
                                                                <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Name</label>
                                                                <div className="text-[#101828] text-[12px] font-medium">{selectedEmployeeDetails.name}</div>
                                                            </div>
                                                            <i className='gusd-edit col-span-2'></i>
                                                        </div> : null
                                                }




                                                <div className="absolute bottom-[20px] left-0 right-0 xl:bottom-[2.083vw] -z-[1]">
                                                    <img src={empDetailsImg} class=" mx-auto" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Dialog >

                {
                    (isVisibleDelete) ?
                        <ReportDeleteDialog
                            isVisibleDelete={isVisibleDelete}
                            setIsVisibleDelete={setIsVisibleDelete}
                            isVisibleDeleteID={isVisibleDeleteID}
                            getMasterData={() => getMasterData()}
                            setIsLoadData={() => setReportLoading(true)}
                            queries={queries.getTimeReportInitiateReport}
                            tableName={"getTimeReportInitiateReport"}
                            mutations={mutations.updateTimeReportInitiateReport}
                        /> : null
                }


                {/* added notification remainer dialog start */}
                <Dialog
                    header="Reminder"
                    visible={ReminderDialog}
                    style={{ width: "30vw" }}
                    onHide={() => {
                        setreminderDialog(false);
                    }}
                    closable={false}
                    footer={footerContentForReminder}
                >
                    <p className="m-0 text-[#0487C8] text-center">
                        <i className="mr-2 pi pi-check-circle"></i>
                        <span className="font-medium text-[18px]">{`By clicking Yes, a reminder will be sent to ${ReminderData?.Assignee} to approve the form. Click No to cancel.`}</span>
                    </p>
                </Dialog>
                {/* added notification remainer dialog end */}

            </Layout >
        </>
    ) : (
        <Login sessionExpired={1} />
    );
}